export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** A time string with format: HH:mm:ss.SSS */
  Time: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** The `Long` scalar type represents 52-bit integers */
  Long: any;
};

export type Query = {
  __typename?: 'Query';
  catalogCategory?: Maybe<CatalogCategory>;
  catalogCategories?: Maybe<Array<Maybe<CatalogCategory>>>;
  catalogCategoriesConnection?: Maybe<CatalogCategoryConnection>;
  catalogImage?: Maybe<CatalogImage>;
  catalogImages?: Maybe<Array<Maybe<CatalogImage>>>;
  catalogImagesConnection?: Maybe<CatalogImageConnection>;
  catalogItemVariation?: Maybe<CatalogItemVariation>;
  catalogItemVariations?: Maybe<Array<Maybe<CatalogItemVariation>>>;
  catalogItemVariationsConnection?: Maybe<CatalogItemVariationConnection>;
  catalogItem?: Maybe<CatalogItem>;
  catalogItems?: Maybe<Array<Maybe<CatalogItem>>>;
  catalogItemsConnection?: Maybe<CatalogItemConnection>;
  catalogModifierList?: Maybe<CatalogModifierList>;
  catalogModifierLists?: Maybe<Array<Maybe<CatalogModifierList>>>;
  catalogModifierListsConnection?: Maybe<CatalogModifierListConnection>;
  catalogModifier?: Maybe<CatalogModifier>;
  catalogModifiers?: Maybe<Array<Maybe<CatalogModifier>>>;
  catalogModifiersConnection?: Maybe<CatalogModifierConnection>;
  catalogTax?: Maybe<CatalogTax>;
  catalogTaxes?: Maybe<Array<Maybe<CatalogTax>>>;
  catalogTaxesConnection?: Maybe<CatalogTaxConnection>;
  jooAdmin?: Maybe<JooAdmin>;
  location?: Maybe<Location>;
  locations?: Maybe<Array<Maybe<Location>>>;
  locationsConnection?: Maybe<LocationConnection>;
  order?: Maybe<Order>;
  orders?: Maybe<Array<Maybe<Order>>>;
  ordersConnection?: Maybe<OrderConnection>;
  payment?: Maybe<Payment>;
  payments?: Maybe<Array<Maybe<Payment>>>;
  paymentsConnection?: Maybe<PaymentConnection>;
  files?: Maybe<Array<Maybe<UploadFile>>>;
  filesConnection?: Maybe<UploadFileConnection>;
  role?: Maybe<UsersPermissionsRole>;
  /** Retrieve all the existing roles. You can't apply filters on this query. */
  roles?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  rolesConnection?: Maybe<UsersPermissionsRoleConnection>;
  user?: Maybe<UsersPermissionsUser>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  usersConnection?: Maybe<UsersPermissionsUserConnection>;
  locationAvailability: Array<TimeSlotAvailability>;
  me?: Maybe<UsersPermissionsMe>;
  checkIfUsernameAvailable: CheckIfUsernameAvailableResponse;
};


export type QueryCatalogCategoryArgs = {
  id: Scalars['ID'];
};


export type QueryCatalogCategoriesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatalogCategoriesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatalogImageArgs = {
  id: Scalars['ID'];
};


export type QueryCatalogImagesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatalogImagesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatalogItemVariationArgs = {
  id: Scalars['ID'];
};


export type QueryCatalogItemVariationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatalogItemVariationsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatalogItemArgs = {
  id: Scalars['ID'];
};


export type QueryCatalogItemsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatalogItemsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatalogModifierListArgs = {
  id: Scalars['ID'];
};


export type QueryCatalogModifierListsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatalogModifierListsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatalogModifierArgs = {
  id: Scalars['ID'];
};


export type QueryCatalogModifiersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatalogModifiersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatalogTaxArgs = {
  id: Scalars['ID'];
};


export type QueryCatalogTaxesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryCatalogTaxesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryLocationArgs = {
  id: Scalars['ID'];
};


export type QueryLocationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryLocationsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryOrderArgs = {
  id: Scalars['ID'];
};


export type QueryOrdersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryOrdersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPaymentArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryPaymentsConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryFilesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRoleArgs = {
  id: Scalars['ID'];
};


export type QueryRolesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryRolesConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryUsersConnectionArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type QueryLocationAvailabilityArgs = {
  locationId: Scalars['String'];
};


export type QueryCheckIfUsernameAvailableArgs = {
  input: Scalars['String'];
};

export type CatalogCategory = {
  __typename?: 'CatalogCategory';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  square_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  meta?: Maybe<ComponentCatalogObjectMeta>;
  ordinal?: Maybe<Scalars['Int']>;
  available_on_joo?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  items?: Maybe<Array<Maybe<CatalogItem>>>;
};


export type CatalogCategoryItemsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ComponentCatalogObjectMeta = {
  __typename?: 'ComponentCatalogObjectMeta';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: Enum_Componentcatalogobjectmeta_Type;
  updated_at?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  present_at_all_locations?: Maybe<Scalars['Boolean']>;
  image_id?: Maybe<Scalars['String']>;
  present_at_location_ids?: Maybe<Scalars['JSON']>;
  absent_at_location_ids?: Maybe<Scalars['JSON']>;
  image?: Maybe<CatalogImage>;
  present_at_locations?: Maybe<Array<Maybe<Location>>>;
  absent_at_locations?: Maybe<Array<Maybe<Location>>>;
};


export type ComponentCatalogObjectMetaPresent_At_LocationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type ComponentCatalogObjectMetaAbsent_At_LocationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export enum Enum_Componentcatalogobjectmeta_Type {
  Item = 'ITEM',
  Image = 'IMAGE',
  Category = 'CATEGORY',
  ItemVariation = 'ITEM_VARIATION',
  Tax = 'TAX',
  Discount = 'DISCOUNT',
  ModifierList = 'MODIFIER_LIST',
  Modifier = 'MODIFIER'
}


export type CatalogImage = {
  __typename?: 'CatalogImage';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  square_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  meta?: Maybe<ComponentCatalogObjectMeta>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type AdminUser = {
  __typename?: 'AdminUser';
  id: Scalars['ID'];
  username?: Maybe<Scalars['String']>;
};

export type Location = {
  __typename?: 'Location';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  square_id: Scalars['String'];
  address?: Maybe<ComponentAddressAddress>;
  business_email?: Maybe<Scalars['String']>;
  business_hours?: Maybe<ComponentAddressBusinessHours>;
  business_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Location_Status>;
  website_url?: Maybe<Scalars['String']>;
  coordinates?: Maybe<ComponentAddressCoordinates>;
  timezone: Scalars['String'];
  lead_time: Scalars['Int'];
  time_slot_increment: Scalars['Int'];
  order_pacing?: Maybe<Array<Maybe<ComponentTimeOrderPacing>>>;
  default_max_orders_per_time_slot?: Maybe<Scalars['Int']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type ComponentAddressAddress = {
  __typename?: 'ComponentAddressAddress';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  postal_code?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  sublocality?: Maybe<Scalars['String']>;
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  address_line_3?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  administrative_district_level_1?: Maybe<Scalars['String']>;
  sublocality_2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  administrative_district_level_2?: Maybe<Scalars['String']>;
  sublocality_3?: Maybe<Scalars['String']>;
  administrative_district_level_3?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
};

export type ComponentAddressBusinessHours = {
  __typename?: 'ComponentAddressBusinessHours';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  periods?: Maybe<Array<Maybe<ComponentTimePeriods>>>;
};

export type ComponentTimePeriods = {
  __typename?: 'ComponentTimePeriods';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  day_of_week: Enum_Componenttimeperiods_Day_Of_Week;
  end_local_time: Scalars['String'];
  start_local_time: Scalars['String'];
};

export enum Enum_Componenttimeperiods_Day_Of_Week {
  Sun = 'SUN',
  Mon = 'MON',
  Tue = 'TUE',
  Wed = 'WED',
  Thu = 'THU',
  Fri = 'FRI',
  Sat = 'SAT'
}

export enum Enum_Location_Status {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ComponentAddressCoordinates = {
  __typename?: 'ComponentAddressCoordinates';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type ComponentTimeOrderPacing = {
  __typename?: 'ComponentTimeOrderPacing';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  start: Scalars['Time'];
  end: Scalars['Time'];
  day_of_week: Enum_Componenttimeorderpacing_Day_Of_Week;
  max_orders_per_time_slot: Scalars['Int'];
};


export enum Enum_Componenttimeorderpacing_Day_Of_Week {
  Sun = 'sun',
  Mon = 'mon',
  Tue = 'tue',
  Wed = 'wed',
  Thu = 'thu',
  Fri = 'fri',
  Sat = 'sat'
}

export type CatalogItem = {
  __typename?: 'CatalogItem';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  square_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  abbreviation?: Maybe<Scalars['String']>;
  available_for_pickup?: Maybe<Scalars['Boolean']>;
  category_id?: Maybe<Scalars['String']>;
  product_type?: Maybe<Enum_Catalogitem_Product_Type>;
  meta?: Maybe<ComponentCatalogObjectMeta>;
  category?: Maybe<CatalogCategory>;
  variation_square_ids?: Maybe<Scalars['JSON']>;
  modifier_list_info?: Maybe<Array<Maybe<ComponentCatalogModifierListInfo>>>;
  tax_ids?: Maybe<Scalars['JSON']>;
  available_on_joo?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  variations?: Maybe<Array<Maybe<CatalogItemVariation>>>;
  taxes?: Maybe<Array<Maybe<CatalogTax>>>;
};


export type CatalogItemVariationsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type CatalogItemTaxesArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export enum Enum_Catalogitem_Product_Type {
  Regular = 'REGULAR',
  GiftCard = 'GIFT_CARD',
  AppointmentsService = 'APPOINTMENTS_SERVICE'
}

export type ComponentCatalogModifierListInfo = {
  __typename?: 'ComponentCatalogModifierListInfo';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  modifier_list?: Maybe<CatalogModifierList>;
  enabled?: Maybe<Scalars['Boolean']>;
  max_selected_modifiers?: Maybe<Scalars['Int']>;
  min_selected_modifiers?: Maybe<Scalars['Int']>;
  modifier_overrides?: Maybe<Array<Maybe<ComponentCatalogModifierOverrides>>>;
  modifier_list_id: Scalars['String'];
};

export type CatalogModifierList = {
  __typename?: 'CatalogModifierList';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name?: Maybe<Scalars['String']>;
  ordinal?: Maybe<Scalars['Int']>;
  selection_type?: Maybe<Enum_Catalogmodifierlist_Selection_Type>;
  meta?: Maybe<ComponentCatalogObjectMeta>;
  modifiers_square_ids?: Maybe<Scalars['JSON']>;
  square_id: Scalars['String'];
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  modifiers?: Maybe<Array<Maybe<CatalogModifier>>>;
};


export type CatalogModifierListModifiersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export enum Enum_Catalogmodifierlist_Selection_Type {
  Single = 'SINGLE',
  Multiple = 'MULTIPLE'
}

export type CatalogModifier = {
  __typename?: 'CatalogModifier';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  square_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  price_money?: Maybe<ComponentMoneyPriceMoney>;
  ordinal?: Maybe<Scalars['Int']>;
  modifier_list_id: Scalars['String'];
  meta?: Maybe<ComponentCatalogObjectMeta>;
  modifier_list?: Maybe<CatalogModifierList>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type ComponentMoneyPriceMoney = {
  __typename?: 'ComponentMoneyPriceMoney';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  amount: Scalars['Int'];
  currency?: Maybe<Scalars['String']>;
};

export type ComponentCatalogModifierOverrides = {
  __typename?: 'ComponentCatalogModifierOverrides';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  modifier_id: Scalars['String'];
  on_by_default?: Maybe<Scalars['Boolean']>;
};

export type CatalogItemVariation = {
  __typename?: 'CatalogItemVariation';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  square_id: Scalars['String'];
  item_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  ordinal?: Maybe<Scalars['Int']>;
  pricing_type?: Maybe<Enum_Catalogitemvariation_Pricing_Type>;
  price_money?: Maybe<ComponentMoneyPriceMoney>;
  meta?: Maybe<ComponentCatalogObjectMeta>;
  item?: Maybe<CatalogItem>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export enum Enum_Catalogitemvariation_Pricing_Type {
  FixedPricing = 'FIXED_PRICING',
  VariablePricing = 'VARIABLE_PRICING'
}

export type CatalogTax = {
  __typename?: 'CatalogTax';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  square_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  calculation_phase?: Maybe<Enum_Catalogtax_Calculation_Phase>;
  inclusion_type?: Maybe<Enum_Catalogtax_Inclusion_Type>;
  percentage?: Maybe<Scalars['Float']>;
  applies_to_custom_amounts?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<ComponentCatalogObjectMeta>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export enum Enum_Catalogtax_Calculation_Phase {
  TaxSubtotalPhase = 'TAX_SUBTOTAL_PHASE',
  TaxTotalPhase = 'TAX_TOTAL_PHASE'
}

export enum Enum_Catalogtax_Inclusion_Type {
  Additive = 'ADDITIVE',
  Inclusive = 'INCLUSIVE'
}

export type CatalogCategoryConnection = {
  __typename?: 'CatalogCategoryConnection';
  values?: Maybe<Array<Maybe<CatalogCategory>>>;
  groupBy?: Maybe<CatalogCategoryGroupBy>;
  aggregate?: Maybe<CatalogCategoryAggregator>;
};

export type CatalogCategoryGroupBy = {
  __typename?: 'CatalogCategoryGroupBy';
  id?: Maybe<Array<Maybe<CatalogCategoryConnectionId>>>;
  _id?: Maybe<Array<Maybe<CatalogCategoryConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<CatalogCategoryConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<CatalogCategoryConnectionUpdatedAt>>>;
  square_id?: Maybe<Array<Maybe<CatalogCategoryConnectionSquare_Id>>>;
  name?: Maybe<Array<Maybe<CatalogCategoryConnectionName>>>;
  meta?: Maybe<Array<Maybe<CatalogCategoryConnectionMeta>>>;
  ordinal?: Maybe<Array<Maybe<CatalogCategoryConnectionOrdinal>>>;
  available_on_joo?: Maybe<Array<Maybe<CatalogCategoryConnectionAvailable_On_Joo>>>;
  created_by?: Maybe<Array<Maybe<CatalogCategoryConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<CatalogCategoryConnectionUpdated_By>>>;
};

export type CatalogCategoryConnectionId = {
  __typename?: 'CatalogCategoryConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogCategoryConnection>;
};

export type CatalogCategoryConnection_Id = {
  __typename?: 'CatalogCategoryConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogCategoryConnection>;
};

export type CatalogCategoryConnectionCreatedAt = {
  __typename?: 'CatalogCategoryConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalogCategoryConnection>;
};

export type CatalogCategoryConnectionUpdatedAt = {
  __typename?: 'CatalogCategoryConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalogCategoryConnection>;
};

export type CatalogCategoryConnectionSquare_Id = {
  __typename?: 'CatalogCategoryConnectionSquare_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogCategoryConnection>;
};

export type CatalogCategoryConnectionName = {
  __typename?: 'CatalogCategoryConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogCategoryConnection>;
};

export type CatalogCategoryConnectionMeta = {
  __typename?: 'CatalogCategoryConnectionMeta';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogCategoryConnection>;
};

export type CatalogCategoryConnectionOrdinal = {
  __typename?: 'CatalogCategoryConnectionOrdinal';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CatalogCategoryConnection>;
};

export type CatalogCategoryConnectionAvailable_On_Joo = {
  __typename?: 'CatalogCategoryConnectionAvailable_on_joo';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CatalogCategoryConnection>;
};

export type CatalogCategoryConnectionCreated_By = {
  __typename?: 'CatalogCategoryConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogCategoryConnection>;
};

export type CatalogCategoryConnectionUpdated_By = {
  __typename?: 'CatalogCategoryConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogCategoryConnection>;
};

export type CatalogCategoryAggregator = {
  __typename?: 'CatalogCategoryAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CatalogCategoryAggregatorSum>;
  avg?: Maybe<CatalogCategoryAggregatorAvg>;
  min?: Maybe<CatalogCategoryAggregatorMin>;
  max?: Maybe<CatalogCategoryAggregatorMax>;
};

export type CatalogCategoryAggregatorSum = {
  __typename?: 'CatalogCategoryAggregatorSum';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogCategoryAggregatorAvg = {
  __typename?: 'CatalogCategoryAggregatorAvg';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogCategoryAggregatorMin = {
  __typename?: 'CatalogCategoryAggregatorMin';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogCategoryAggregatorMax = {
  __typename?: 'CatalogCategoryAggregatorMax';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogImageConnection = {
  __typename?: 'CatalogImageConnection';
  values?: Maybe<Array<Maybe<CatalogImage>>>;
  groupBy?: Maybe<CatalogImageGroupBy>;
  aggregate?: Maybe<CatalogImageAggregator>;
};

export type CatalogImageGroupBy = {
  __typename?: 'CatalogImageGroupBy';
  id?: Maybe<Array<Maybe<CatalogImageConnectionId>>>;
  _id?: Maybe<Array<Maybe<CatalogImageConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<CatalogImageConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<CatalogImageConnectionUpdatedAt>>>;
  square_id?: Maybe<Array<Maybe<CatalogImageConnectionSquare_Id>>>;
  name?: Maybe<Array<Maybe<CatalogImageConnectionName>>>;
  url?: Maybe<Array<Maybe<CatalogImageConnectionUrl>>>;
  caption?: Maybe<Array<Maybe<CatalogImageConnectionCaption>>>;
  meta?: Maybe<Array<Maybe<CatalogImageConnectionMeta>>>;
  created_by?: Maybe<Array<Maybe<CatalogImageConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<CatalogImageConnectionUpdated_By>>>;
};

export type CatalogImageConnectionId = {
  __typename?: 'CatalogImageConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogImageConnection>;
};

export type CatalogImageConnection_Id = {
  __typename?: 'CatalogImageConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogImageConnection>;
};

export type CatalogImageConnectionCreatedAt = {
  __typename?: 'CatalogImageConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalogImageConnection>;
};

export type CatalogImageConnectionUpdatedAt = {
  __typename?: 'CatalogImageConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalogImageConnection>;
};

export type CatalogImageConnectionSquare_Id = {
  __typename?: 'CatalogImageConnectionSquare_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogImageConnection>;
};

export type CatalogImageConnectionName = {
  __typename?: 'CatalogImageConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogImageConnection>;
};

export type CatalogImageConnectionUrl = {
  __typename?: 'CatalogImageConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogImageConnection>;
};

export type CatalogImageConnectionCaption = {
  __typename?: 'CatalogImageConnectionCaption';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogImageConnection>;
};

export type CatalogImageConnectionMeta = {
  __typename?: 'CatalogImageConnectionMeta';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogImageConnection>;
};

export type CatalogImageConnectionCreated_By = {
  __typename?: 'CatalogImageConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogImageConnection>;
};

export type CatalogImageConnectionUpdated_By = {
  __typename?: 'CatalogImageConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogImageConnection>;
};

export type CatalogImageAggregator = {
  __typename?: 'CatalogImageAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CatalogItemVariationConnection = {
  __typename?: 'CatalogItemVariationConnection';
  values?: Maybe<Array<Maybe<CatalogItemVariation>>>;
  groupBy?: Maybe<CatalogItemVariationGroupBy>;
  aggregate?: Maybe<CatalogItemVariationAggregator>;
};

export type CatalogItemVariationGroupBy = {
  __typename?: 'CatalogItemVariationGroupBy';
  id?: Maybe<Array<Maybe<CatalogItemVariationConnectionId>>>;
  _id?: Maybe<Array<Maybe<CatalogItemVariationConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<CatalogItemVariationConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<CatalogItemVariationConnectionUpdatedAt>>>;
  square_id?: Maybe<Array<Maybe<CatalogItemVariationConnectionSquare_Id>>>;
  item_id?: Maybe<Array<Maybe<CatalogItemVariationConnectionItem_Id>>>;
  name?: Maybe<Array<Maybe<CatalogItemVariationConnectionName>>>;
  ordinal?: Maybe<Array<Maybe<CatalogItemVariationConnectionOrdinal>>>;
  pricing_type?: Maybe<Array<Maybe<CatalogItemVariationConnectionPricing_Type>>>;
  price_money?: Maybe<Array<Maybe<CatalogItemVariationConnectionPrice_Money>>>;
  meta?: Maybe<Array<Maybe<CatalogItemVariationConnectionMeta>>>;
  item?: Maybe<Array<Maybe<CatalogItemVariationConnectionItem>>>;
  created_by?: Maybe<Array<Maybe<CatalogItemVariationConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<CatalogItemVariationConnectionUpdated_By>>>;
};

export type CatalogItemVariationConnectionId = {
  __typename?: 'CatalogItemVariationConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogItemVariationConnection>;
};

export type CatalogItemVariationConnection_Id = {
  __typename?: 'CatalogItemVariationConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogItemVariationConnection>;
};

export type CatalogItemVariationConnectionCreatedAt = {
  __typename?: 'CatalogItemVariationConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalogItemVariationConnection>;
};

export type CatalogItemVariationConnectionUpdatedAt = {
  __typename?: 'CatalogItemVariationConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalogItemVariationConnection>;
};

export type CatalogItemVariationConnectionSquare_Id = {
  __typename?: 'CatalogItemVariationConnectionSquare_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogItemVariationConnection>;
};

export type CatalogItemVariationConnectionItem_Id = {
  __typename?: 'CatalogItemVariationConnectionItem_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogItemVariationConnection>;
};

export type CatalogItemVariationConnectionName = {
  __typename?: 'CatalogItemVariationConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogItemVariationConnection>;
};

export type CatalogItemVariationConnectionOrdinal = {
  __typename?: 'CatalogItemVariationConnectionOrdinal';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CatalogItemVariationConnection>;
};

export type CatalogItemVariationConnectionPricing_Type = {
  __typename?: 'CatalogItemVariationConnectionPricing_type';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogItemVariationConnection>;
};

export type CatalogItemVariationConnectionPrice_Money = {
  __typename?: 'CatalogItemVariationConnectionPrice_money';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogItemVariationConnection>;
};

export type CatalogItemVariationConnectionMeta = {
  __typename?: 'CatalogItemVariationConnectionMeta';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogItemVariationConnection>;
};

export type CatalogItemVariationConnectionItem = {
  __typename?: 'CatalogItemVariationConnectionItem';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogItemVariationConnection>;
};

export type CatalogItemVariationConnectionCreated_By = {
  __typename?: 'CatalogItemVariationConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogItemVariationConnection>;
};

export type CatalogItemVariationConnectionUpdated_By = {
  __typename?: 'CatalogItemVariationConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogItemVariationConnection>;
};

export type CatalogItemVariationAggregator = {
  __typename?: 'CatalogItemVariationAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CatalogItemVariationAggregatorSum>;
  avg?: Maybe<CatalogItemVariationAggregatorAvg>;
  min?: Maybe<CatalogItemVariationAggregatorMin>;
  max?: Maybe<CatalogItemVariationAggregatorMax>;
};

export type CatalogItemVariationAggregatorSum = {
  __typename?: 'CatalogItemVariationAggregatorSum';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogItemVariationAggregatorAvg = {
  __typename?: 'CatalogItemVariationAggregatorAvg';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogItemVariationAggregatorMin = {
  __typename?: 'CatalogItemVariationAggregatorMin';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogItemVariationAggregatorMax = {
  __typename?: 'CatalogItemVariationAggregatorMax';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogItemConnection = {
  __typename?: 'CatalogItemConnection';
  values?: Maybe<Array<Maybe<CatalogItem>>>;
  groupBy?: Maybe<CatalogItemGroupBy>;
  aggregate?: Maybe<CatalogItemAggregator>;
};

export type CatalogItemGroupBy = {
  __typename?: 'CatalogItemGroupBy';
  id?: Maybe<Array<Maybe<CatalogItemConnectionId>>>;
  _id?: Maybe<Array<Maybe<CatalogItemConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<CatalogItemConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<CatalogItemConnectionUpdatedAt>>>;
  square_id?: Maybe<Array<Maybe<CatalogItemConnectionSquare_Id>>>;
  name?: Maybe<Array<Maybe<CatalogItemConnectionName>>>;
  description?: Maybe<Array<Maybe<CatalogItemConnectionDescription>>>;
  abbreviation?: Maybe<Array<Maybe<CatalogItemConnectionAbbreviation>>>;
  available_for_pickup?: Maybe<Array<Maybe<CatalogItemConnectionAvailable_For_Pickup>>>;
  category_id?: Maybe<Array<Maybe<CatalogItemConnectionCategory_Id>>>;
  product_type?: Maybe<Array<Maybe<CatalogItemConnectionProduct_Type>>>;
  meta?: Maybe<Array<Maybe<CatalogItemConnectionMeta>>>;
  category?: Maybe<Array<Maybe<CatalogItemConnectionCategory>>>;
  variation_square_ids?: Maybe<Array<Maybe<CatalogItemConnectionVariation_Square_Ids>>>;
  tax_ids?: Maybe<Array<Maybe<CatalogItemConnectionTax_Ids>>>;
  available_on_joo?: Maybe<Array<Maybe<CatalogItemConnectionAvailable_On_Joo>>>;
  created_by?: Maybe<Array<Maybe<CatalogItemConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<CatalogItemConnectionUpdated_By>>>;
};

export type CatalogItemConnectionId = {
  __typename?: 'CatalogItemConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnection_Id = {
  __typename?: 'CatalogItemConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionCreatedAt = {
  __typename?: 'CatalogItemConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionUpdatedAt = {
  __typename?: 'CatalogItemConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionSquare_Id = {
  __typename?: 'CatalogItemConnectionSquare_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionName = {
  __typename?: 'CatalogItemConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionDescription = {
  __typename?: 'CatalogItemConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionAbbreviation = {
  __typename?: 'CatalogItemConnectionAbbreviation';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionAvailable_For_Pickup = {
  __typename?: 'CatalogItemConnectionAvailable_for_pickup';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionCategory_Id = {
  __typename?: 'CatalogItemConnectionCategory_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionProduct_Type = {
  __typename?: 'CatalogItemConnectionProduct_type';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionMeta = {
  __typename?: 'CatalogItemConnectionMeta';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionCategory = {
  __typename?: 'CatalogItemConnectionCategory';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionVariation_Square_Ids = {
  __typename?: 'CatalogItemConnectionVariation_square_ids';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionTax_Ids = {
  __typename?: 'CatalogItemConnectionTax_ids';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionAvailable_On_Joo = {
  __typename?: 'CatalogItemConnectionAvailable_on_joo';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionCreated_By = {
  __typename?: 'CatalogItemConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemConnectionUpdated_By = {
  __typename?: 'CatalogItemConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogItemConnection>;
};

export type CatalogItemAggregator = {
  __typename?: 'CatalogItemAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CatalogModifierListConnection = {
  __typename?: 'CatalogModifierListConnection';
  values?: Maybe<Array<Maybe<CatalogModifierList>>>;
  groupBy?: Maybe<CatalogModifierListGroupBy>;
  aggregate?: Maybe<CatalogModifierListAggregator>;
};

export type CatalogModifierListGroupBy = {
  __typename?: 'CatalogModifierListGroupBy';
  id?: Maybe<Array<Maybe<CatalogModifierListConnectionId>>>;
  _id?: Maybe<Array<Maybe<CatalogModifierListConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<CatalogModifierListConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<CatalogModifierListConnectionUpdatedAt>>>;
  name?: Maybe<Array<Maybe<CatalogModifierListConnectionName>>>;
  ordinal?: Maybe<Array<Maybe<CatalogModifierListConnectionOrdinal>>>;
  selection_type?: Maybe<Array<Maybe<CatalogModifierListConnectionSelection_Type>>>;
  meta?: Maybe<Array<Maybe<CatalogModifierListConnectionMeta>>>;
  modifiers_square_ids?: Maybe<Array<Maybe<CatalogModifierListConnectionModifiers_Square_Ids>>>;
  square_id?: Maybe<Array<Maybe<CatalogModifierListConnectionSquare_Id>>>;
  created_by?: Maybe<Array<Maybe<CatalogModifierListConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<CatalogModifierListConnectionUpdated_By>>>;
};

export type CatalogModifierListConnectionId = {
  __typename?: 'CatalogModifierListConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogModifierListConnection>;
};

export type CatalogModifierListConnection_Id = {
  __typename?: 'CatalogModifierListConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogModifierListConnection>;
};

export type CatalogModifierListConnectionCreatedAt = {
  __typename?: 'CatalogModifierListConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalogModifierListConnection>;
};

export type CatalogModifierListConnectionUpdatedAt = {
  __typename?: 'CatalogModifierListConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalogModifierListConnection>;
};

export type CatalogModifierListConnectionName = {
  __typename?: 'CatalogModifierListConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogModifierListConnection>;
};

export type CatalogModifierListConnectionOrdinal = {
  __typename?: 'CatalogModifierListConnectionOrdinal';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CatalogModifierListConnection>;
};

export type CatalogModifierListConnectionSelection_Type = {
  __typename?: 'CatalogModifierListConnectionSelection_type';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogModifierListConnection>;
};

export type CatalogModifierListConnectionMeta = {
  __typename?: 'CatalogModifierListConnectionMeta';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogModifierListConnection>;
};

export type CatalogModifierListConnectionModifiers_Square_Ids = {
  __typename?: 'CatalogModifierListConnectionModifiers_square_ids';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<CatalogModifierListConnection>;
};

export type CatalogModifierListConnectionSquare_Id = {
  __typename?: 'CatalogModifierListConnectionSquare_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogModifierListConnection>;
};

export type CatalogModifierListConnectionCreated_By = {
  __typename?: 'CatalogModifierListConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogModifierListConnection>;
};

export type CatalogModifierListConnectionUpdated_By = {
  __typename?: 'CatalogModifierListConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogModifierListConnection>;
};

export type CatalogModifierListAggregator = {
  __typename?: 'CatalogModifierListAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CatalogModifierListAggregatorSum>;
  avg?: Maybe<CatalogModifierListAggregatorAvg>;
  min?: Maybe<CatalogModifierListAggregatorMin>;
  max?: Maybe<CatalogModifierListAggregatorMax>;
};

export type CatalogModifierListAggregatorSum = {
  __typename?: 'CatalogModifierListAggregatorSum';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogModifierListAggregatorAvg = {
  __typename?: 'CatalogModifierListAggregatorAvg';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogModifierListAggregatorMin = {
  __typename?: 'CatalogModifierListAggregatorMin';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogModifierListAggregatorMax = {
  __typename?: 'CatalogModifierListAggregatorMax';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogModifierConnection = {
  __typename?: 'CatalogModifierConnection';
  values?: Maybe<Array<Maybe<CatalogModifier>>>;
  groupBy?: Maybe<CatalogModifierGroupBy>;
  aggregate?: Maybe<CatalogModifierAggregator>;
};

export type CatalogModifierGroupBy = {
  __typename?: 'CatalogModifierGroupBy';
  id?: Maybe<Array<Maybe<CatalogModifierConnectionId>>>;
  _id?: Maybe<Array<Maybe<CatalogModifierConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<CatalogModifierConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<CatalogModifierConnectionUpdatedAt>>>;
  square_id?: Maybe<Array<Maybe<CatalogModifierConnectionSquare_Id>>>;
  name?: Maybe<Array<Maybe<CatalogModifierConnectionName>>>;
  price_money?: Maybe<Array<Maybe<CatalogModifierConnectionPrice_Money>>>;
  ordinal?: Maybe<Array<Maybe<CatalogModifierConnectionOrdinal>>>;
  modifier_list_id?: Maybe<Array<Maybe<CatalogModifierConnectionModifier_List_Id>>>;
  meta?: Maybe<Array<Maybe<CatalogModifierConnectionMeta>>>;
  modifier_list?: Maybe<Array<Maybe<CatalogModifierConnectionModifier_List>>>;
  created_by?: Maybe<Array<Maybe<CatalogModifierConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<CatalogModifierConnectionUpdated_By>>>;
};

export type CatalogModifierConnectionId = {
  __typename?: 'CatalogModifierConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogModifierConnection>;
};

export type CatalogModifierConnection_Id = {
  __typename?: 'CatalogModifierConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogModifierConnection>;
};

export type CatalogModifierConnectionCreatedAt = {
  __typename?: 'CatalogModifierConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalogModifierConnection>;
};

export type CatalogModifierConnectionUpdatedAt = {
  __typename?: 'CatalogModifierConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalogModifierConnection>;
};

export type CatalogModifierConnectionSquare_Id = {
  __typename?: 'CatalogModifierConnectionSquare_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogModifierConnection>;
};

export type CatalogModifierConnectionName = {
  __typename?: 'CatalogModifierConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogModifierConnection>;
};

export type CatalogModifierConnectionPrice_Money = {
  __typename?: 'CatalogModifierConnectionPrice_money';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogModifierConnection>;
};

export type CatalogModifierConnectionOrdinal = {
  __typename?: 'CatalogModifierConnectionOrdinal';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<CatalogModifierConnection>;
};

export type CatalogModifierConnectionModifier_List_Id = {
  __typename?: 'CatalogModifierConnectionModifier_list_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogModifierConnection>;
};

export type CatalogModifierConnectionMeta = {
  __typename?: 'CatalogModifierConnectionMeta';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogModifierConnection>;
};

export type CatalogModifierConnectionModifier_List = {
  __typename?: 'CatalogModifierConnectionModifier_list';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogModifierConnection>;
};

export type CatalogModifierConnectionCreated_By = {
  __typename?: 'CatalogModifierConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogModifierConnection>;
};

export type CatalogModifierConnectionUpdated_By = {
  __typename?: 'CatalogModifierConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogModifierConnection>;
};

export type CatalogModifierAggregator = {
  __typename?: 'CatalogModifierAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CatalogModifierAggregatorSum>;
  avg?: Maybe<CatalogModifierAggregatorAvg>;
  min?: Maybe<CatalogModifierAggregatorMin>;
  max?: Maybe<CatalogModifierAggregatorMax>;
};

export type CatalogModifierAggregatorSum = {
  __typename?: 'CatalogModifierAggregatorSum';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogModifierAggregatorAvg = {
  __typename?: 'CatalogModifierAggregatorAvg';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogModifierAggregatorMin = {
  __typename?: 'CatalogModifierAggregatorMin';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogModifierAggregatorMax = {
  __typename?: 'CatalogModifierAggregatorMax';
  ordinal?: Maybe<Scalars['Float']>;
};

export type CatalogTaxConnection = {
  __typename?: 'CatalogTaxConnection';
  values?: Maybe<Array<Maybe<CatalogTax>>>;
  groupBy?: Maybe<CatalogTaxGroupBy>;
  aggregate?: Maybe<CatalogTaxAggregator>;
};

export type CatalogTaxGroupBy = {
  __typename?: 'CatalogTaxGroupBy';
  id?: Maybe<Array<Maybe<CatalogTaxConnectionId>>>;
  _id?: Maybe<Array<Maybe<CatalogTaxConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<CatalogTaxConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<CatalogTaxConnectionUpdatedAt>>>;
  square_id?: Maybe<Array<Maybe<CatalogTaxConnectionSquare_Id>>>;
  name?: Maybe<Array<Maybe<CatalogTaxConnectionName>>>;
  calculation_phase?: Maybe<Array<Maybe<CatalogTaxConnectionCalculation_Phase>>>;
  inclusion_type?: Maybe<Array<Maybe<CatalogTaxConnectionInclusion_Type>>>;
  percentage?: Maybe<Array<Maybe<CatalogTaxConnectionPercentage>>>;
  applies_to_custom_amounts?: Maybe<Array<Maybe<CatalogTaxConnectionApplies_To_Custom_Amounts>>>;
  enabled?: Maybe<Array<Maybe<CatalogTaxConnectionEnabled>>>;
  meta?: Maybe<Array<Maybe<CatalogTaxConnectionMeta>>>;
  created_by?: Maybe<Array<Maybe<CatalogTaxConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<CatalogTaxConnectionUpdated_By>>>;
};

export type CatalogTaxConnectionId = {
  __typename?: 'CatalogTaxConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogTaxConnection>;
};

export type CatalogTaxConnection_Id = {
  __typename?: 'CatalogTaxConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogTaxConnection>;
};

export type CatalogTaxConnectionCreatedAt = {
  __typename?: 'CatalogTaxConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalogTaxConnection>;
};

export type CatalogTaxConnectionUpdatedAt = {
  __typename?: 'CatalogTaxConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<CatalogTaxConnection>;
};

export type CatalogTaxConnectionSquare_Id = {
  __typename?: 'CatalogTaxConnectionSquare_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogTaxConnection>;
};

export type CatalogTaxConnectionName = {
  __typename?: 'CatalogTaxConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogTaxConnection>;
};

export type CatalogTaxConnectionCalculation_Phase = {
  __typename?: 'CatalogTaxConnectionCalculation_phase';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogTaxConnection>;
};

export type CatalogTaxConnectionInclusion_Type = {
  __typename?: 'CatalogTaxConnectionInclusion_type';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<CatalogTaxConnection>;
};

export type CatalogTaxConnectionPercentage = {
  __typename?: 'CatalogTaxConnectionPercentage';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<CatalogTaxConnection>;
};

export type CatalogTaxConnectionApplies_To_Custom_Amounts = {
  __typename?: 'CatalogTaxConnectionApplies_to_custom_amounts';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CatalogTaxConnection>;
};

export type CatalogTaxConnectionEnabled = {
  __typename?: 'CatalogTaxConnectionEnabled';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<CatalogTaxConnection>;
};

export type CatalogTaxConnectionMeta = {
  __typename?: 'CatalogTaxConnectionMeta';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogTaxConnection>;
};

export type CatalogTaxConnectionCreated_By = {
  __typename?: 'CatalogTaxConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogTaxConnection>;
};

export type CatalogTaxConnectionUpdated_By = {
  __typename?: 'CatalogTaxConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<CatalogTaxConnection>;
};

export type CatalogTaxAggregator = {
  __typename?: 'CatalogTaxAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<CatalogTaxAggregatorSum>;
  avg?: Maybe<CatalogTaxAggregatorAvg>;
  min?: Maybe<CatalogTaxAggregatorMin>;
  max?: Maybe<CatalogTaxAggregatorMax>;
};

export type CatalogTaxAggregatorSum = {
  __typename?: 'CatalogTaxAggregatorSum';
  percentage?: Maybe<Scalars['Float']>;
};

export type CatalogTaxAggregatorAvg = {
  __typename?: 'CatalogTaxAggregatorAvg';
  percentage?: Maybe<Scalars['Float']>;
};

export type CatalogTaxAggregatorMin = {
  __typename?: 'CatalogTaxAggregatorMin';
  percentage?: Maybe<Scalars['Float']>;
};

export type CatalogTaxAggregatorMax = {
  __typename?: 'CatalogTaxAggregatorMax';
  percentage?: Maybe<Scalars['Float']>;
};

export type JooAdmin = {
  __typename?: 'JooAdmin';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  catalogSyncInProgress?: Maybe<Scalars['Boolean']>;
  catalogSyncRequested?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type LocationConnection = {
  __typename?: 'LocationConnection';
  values?: Maybe<Array<Maybe<Location>>>;
  groupBy?: Maybe<LocationGroupBy>;
  aggregate?: Maybe<LocationAggregator>;
};

export type LocationGroupBy = {
  __typename?: 'LocationGroupBy';
  id?: Maybe<Array<Maybe<LocationConnectionId>>>;
  _id?: Maybe<Array<Maybe<LocationConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<LocationConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<LocationConnectionUpdatedAt>>>;
  square_id?: Maybe<Array<Maybe<LocationConnectionSquare_Id>>>;
  address?: Maybe<Array<Maybe<LocationConnectionAddress>>>;
  business_email?: Maybe<Array<Maybe<LocationConnectionBusiness_Email>>>;
  business_hours?: Maybe<Array<Maybe<LocationConnectionBusiness_Hours>>>;
  business_name?: Maybe<Array<Maybe<LocationConnectionBusiness_Name>>>;
  country?: Maybe<Array<Maybe<LocationConnectionCountry>>>;
  description?: Maybe<Array<Maybe<LocationConnectionDescription>>>;
  name?: Maybe<Array<Maybe<LocationConnectionName>>>;
  phone_number?: Maybe<Array<Maybe<LocationConnectionPhone_Number>>>;
  status?: Maybe<Array<Maybe<LocationConnectionStatus>>>;
  website_url?: Maybe<Array<Maybe<LocationConnectionWebsite_Url>>>;
  coordinates?: Maybe<Array<Maybe<LocationConnectionCoordinates>>>;
  timezone?: Maybe<Array<Maybe<LocationConnectionTimezone>>>;
  lead_time?: Maybe<Array<Maybe<LocationConnectionLead_Time>>>;
  time_slot_increment?: Maybe<Array<Maybe<LocationConnectionTime_Slot_Increment>>>;
  default_max_orders_per_time_slot?: Maybe<Array<Maybe<LocationConnectionDefault_Max_Orders_Per_Time_Slot>>>;
  created_by?: Maybe<Array<Maybe<LocationConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<LocationConnectionUpdated_By>>>;
};

export type LocationConnectionId = {
  __typename?: 'LocationConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnection_Id = {
  __typename?: 'LocationConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionCreatedAt = {
  __typename?: 'LocationConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionUpdatedAt = {
  __typename?: 'LocationConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionSquare_Id = {
  __typename?: 'LocationConnectionSquare_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionAddress = {
  __typename?: 'LocationConnectionAddress';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionBusiness_Email = {
  __typename?: 'LocationConnectionBusiness_email';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionBusiness_Hours = {
  __typename?: 'LocationConnectionBusiness_hours';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionBusiness_Name = {
  __typename?: 'LocationConnectionBusiness_name';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionCountry = {
  __typename?: 'LocationConnectionCountry';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionDescription = {
  __typename?: 'LocationConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionName = {
  __typename?: 'LocationConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionPhone_Number = {
  __typename?: 'LocationConnectionPhone_number';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionStatus = {
  __typename?: 'LocationConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionWebsite_Url = {
  __typename?: 'LocationConnectionWebsite_url';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionCoordinates = {
  __typename?: 'LocationConnectionCoordinates';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionTimezone = {
  __typename?: 'LocationConnectionTimezone';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionLead_Time = {
  __typename?: 'LocationConnectionLead_time';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionTime_Slot_Increment = {
  __typename?: 'LocationConnectionTime_slot_increment';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionDefault_Max_Orders_Per_Time_Slot = {
  __typename?: 'LocationConnectionDefault_max_orders_per_time_slot';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionCreated_By = {
  __typename?: 'LocationConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationConnectionUpdated_By = {
  __typename?: 'LocationConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<LocationConnection>;
};

export type LocationAggregator = {
  __typename?: 'LocationAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<LocationAggregatorSum>;
  avg?: Maybe<LocationAggregatorAvg>;
  min?: Maybe<LocationAggregatorMin>;
  max?: Maybe<LocationAggregatorMax>;
};

export type LocationAggregatorSum = {
  __typename?: 'LocationAggregatorSum';
  lead_time?: Maybe<Scalars['Float']>;
  time_slot_increment?: Maybe<Scalars['Float']>;
  default_max_orders_per_time_slot?: Maybe<Scalars['Float']>;
};

export type LocationAggregatorAvg = {
  __typename?: 'LocationAggregatorAvg';
  lead_time?: Maybe<Scalars['Float']>;
  time_slot_increment?: Maybe<Scalars['Float']>;
  default_max_orders_per_time_slot?: Maybe<Scalars['Float']>;
};

export type LocationAggregatorMin = {
  __typename?: 'LocationAggregatorMin';
  lead_time?: Maybe<Scalars['Float']>;
  time_slot_increment?: Maybe<Scalars['Float']>;
  default_max_orders_per_time_slot?: Maybe<Scalars['Float']>;
};

export type LocationAggregatorMax = {
  __typename?: 'LocationAggregatorMax';
  lead_time?: Maybe<Scalars['Float']>;
  time_slot_increment?: Maybe<Scalars['Float']>;
  default_max_orders_per_time_slot?: Maybe<Scalars['Float']>;
};

export type Order = {
  __typename?: 'Order';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  square_id?: Maybe<Scalars['String']>;
  location_id: Scalars['String'];
  customer_id?: Maybe<Scalars['String']>;
  line_items?: Maybe<Array<Maybe<ComponentOrderLineItem>>>;
  fulfillments?: Maybe<Array<Maybe<ComponentOrderFulfillment>>>;
  created_at?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  closed_at?: Maybe<Scalars['String']>;
  state?: Maybe<Enum_Order_State>;
  version?: Maybe<Scalars['Int']>;
  total_money?: Maybe<ComponentMoneyPriceMoney>;
  total_tax_money?: Maybe<ComponentMoneyPriceMoney>;
  total_discount_money?: Maybe<ComponentMoneyPriceMoney>;
  receipt_url?: Maybe<Scalars['String']>;
  receipt_number?: Maybe<Scalars['String']>;
  total_tip_money?: Maybe<ComponentMoneyPriceMoney>;
  current_pickup_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type ComponentOrderLineItem = {
  __typename?: 'ComponentOrderLineItem';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  quantity: Scalars['String'];
  catalog_object_id: Scalars['String'];
  modifiers?: Maybe<Array<Maybe<ComponentOrderOrderLineItemModifier>>>;
  note?: Maybe<Scalars['String']>;
};

export type ComponentOrderOrderLineItemModifier = {
  __typename?: 'ComponentOrderOrderLineItemModifier';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  catalog_object_id: Scalars['String'];
};

export type ComponentOrderFulfillment = {
  __typename?: 'ComponentOrderFulfillment';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  pickup_details?: Maybe<ComponentOrderFulfillmentPickupDetails>;
  state?: Maybe<Enum_Componentorderfulfillment_State>;
  type?: Maybe<Enum_Componentorderfulfillment_Type>;
  uid?: Maybe<Scalars['String']>;
};

export type ComponentOrderFulfillmentPickupDetails = {
  __typename?: 'ComponentOrderFulfillmentPickupDetails';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  pickup_window_duration?: Maybe<Scalars['String']>;
  schedule_type?: Maybe<Enum_Componentorderfulfillmentpickupdetails_Schedule_Type>;
  cancel_reason?: Maybe<Scalars['String']>;
  auto_complete_duration?: Maybe<Scalars['String']>;
  accepted_at?: Maybe<Scalars['String']>;
  expired_at?: Maybe<Scalars['String']>;
  ready_at?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  prep_time_duration?: Maybe<Scalars['String']>;
  rejected_at?: Maybe<Scalars['String']>;
  placed_at?: Maybe<Scalars['String']>;
  pickup_at?: Maybe<Scalars['String']>;
  picked_up_at?: Maybe<Scalars['String']>;
  canceled_at?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['String']>;
};

export enum Enum_Componentorderfulfillmentpickupdetails_Schedule_Type {
  Scheduled = 'SCHEDULED',
  Asap = 'ASAP'
}

export enum Enum_Componentorderfulfillment_State {
  Proposed = 'PROPOSED',
  Reserved = 'RESERVED',
  Prepared = 'PREPARED',
  Completed = 'COMPLETED',
  Canceled = 'CANCELED',
  Failed = 'FAILED'
}

export enum Enum_Componentorderfulfillment_Type {
  Pickup = 'PICKUP',
  Shipment = 'SHIPMENT'
}

export enum Enum_Order_State {
  Open = 'OPEN',
  Completed = 'COMPLETED',
  Canceled = 'CANCELED'
}

export type OrderConnection = {
  __typename?: 'OrderConnection';
  values?: Maybe<Array<Maybe<Order>>>;
  groupBy?: Maybe<OrderGroupBy>;
  aggregate?: Maybe<OrderAggregator>;
};

export type OrderGroupBy = {
  __typename?: 'OrderGroupBy';
  id?: Maybe<Array<Maybe<OrderConnectionId>>>;
  _id?: Maybe<Array<Maybe<OrderConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<OrderConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<OrderConnectionUpdatedAt>>>;
  square_id?: Maybe<Array<Maybe<OrderConnectionSquare_Id>>>;
  location_id?: Maybe<Array<Maybe<OrderConnectionLocation_Id>>>;
  customer_id?: Maybe<Array<Maybe<OrderConnectionCustomer_Id>>>;
  created_at?: Maybe<Array<Maybe<OrderConnectionCreated_At>>>;
  updated_at?: Maybe<Array<Maybe<OrderConnectionUpdated_At>>>;
  closed_at?: Maybe<Array<Maybe<OrderConnectionClosed_At>>>;
  state?: Maybe<Array<Maybe<OrderConnectionState>>>;
  version?: Maybe<Array<Maybe<OrderConnectionVersion>>>;
  total_money?: Maybe<Array<Maybe<OrderConnectionTotal_Money>>>;
  total_tax_money?: Maybe<Array<Maybe<OrderConnectionTotal_Tax_Money>>>;
  total_discount_money?: Maybe<Array<Maybe<OrderConnectionTotal_Discount_Money>>>;
  receipt_url?: Maybe<Array<Maybe<OrderConnectionReceipt_Url>>>;
  receipt_number?: Maybe<Array<Maybe<OrderConnectionReceipt_Number>>>;
  total_tip_money?: Maybe<Array<Maybe<OrderConnectionTotal_Tip_Money>>>;
  current_pickup_at?: Maybe<Array<Maybe<OrderConnectionCurrent_Pickup_At>>>;
  created_by?: Maybe<Array<Maybe<OrderConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<OrderConnectionUpdated_By>>>;
};

export type OrderConnectionId = {
  __typename?: 'OrderConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnection_Id = {
  __typename?: 'OrderConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionCreatedAt = {
  __typename?: 'OrderConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionUpdatedAt = {
  __typename?: 'OrderConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionSquare_Id = {
  __typename?: 'OrderConnectionSquare_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionLocation_Id = {
  __typename?: 'OrderConnectionLocation_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionCustomer_Id = {
  __typename?: 'OrderConnectionCustomer_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionCreated_At = {
  __typename?: 'OrderConnectionCreated_at';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionUpdated_At = {
  __typename?: 'OrderConnectionUpdated_at';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionClosed_At = {
  __typename?: 'OrderConnectionClosed_at';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionState = {
  __typename?: 'OrderConnectionState';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionVersion = {
  __typename?: 'OrderConnectionVersion';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionTotal_Money = {
  __typename?: 'OrderConnectionTotal_money';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionTotal_Tax_Money = {
  __typename?: 'OrderConnectionTotal_tax_money';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionTotal_Discount_Money = {
  __typename?: 'OrderConnectionTotal_discount_money';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionReceipt_Url = {
  __typename?: 'OrderConnectionReceipt_url';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionReceipt_Number = {
  __typename?: 'OrderConnectionReceipt_number';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionTotal_Tip_Money = {
  __typename?: 'OrderConnectionTotal_tip_money';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionCurrent_Pickup_At = {
  __typename?: 'OrderConnectionCurrent_pickup_at';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionCreated_By = {
  __typename?: 'OrderConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderConnectionUpdated_By = {
  __typename?: 'OrderConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<OrderConnection>;
};

export type OrderAggregator = {
  __typename?: 'OrderAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<OrderAggregatorSum>;
  avg?: Maybe<OrderAggregatorAvg>;
  min?: Maybe<OrderAggregatorMin>;
  max?: Maybe<OrderAggregatorMax>;
};

export type OrderAggregatorSum = {
  __typename?: 'OrderAggregatorSum';
  version?: Maybe<Scalars['Float']>;
};

export type OrderAggregatorAvg = {
  __typename?: 'OrderAggregatorAvg';
  version?: Maybe<Scalars['Float']>;
};

export type OrderAggregatorMin = {
  __typename?: 'OrderAggregatorMin';
  version?: Maybe<Scalars['Float']>;
};

export type OrderAggregatorMax = {
  __typename?: 'OrderAggregatorMax';
  version?: Maybe<Scalars['Float']>;
};

export type Payment = {
  __typename?: 'Payment';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  square_id?: Maybe<Scalars['String']>;
  amount_money?: Maybe<ComponentMoneyPriceMoney>;
  tip_money?: Maybe<ComponentMoneyPriceMoney>;
  total_money?: Maybe<ComponentMoneyPriceMoney>;
  app_fee_money?: Maybe<ComponentMoneyPriceMoney>;
  processing_fee?: Maybe<Array<Maybe<ComponentMoneyProcessingFee>>>;
  refunded_money?: Maybe<ComponentMoneyPriceMoney>;
  status?: Maybe<Enum_Payment_Status>;
  source_type?: Maybe<Enum_Payment_Source_Type>;
  location_id?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  buyer_email_address?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  receipt_number?: Maybe<Scalars['String']>;
  receipt_url?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type ComponentMoneyProcessingFee = {
  __typename?: 'ComponentMoneyProcessingFee';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  effective_at?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Componentmoneyprocessingfee_Type>;
  amount_money?: Maybe<ComponentMoneyPriceMoney>;
};

export enum Enum_Componentmoneyprocessingfee_Type {
  Initial = 'INITIAL',
  Adjustment = 'ADJUSTMENT'
}

export enum Enum_Payment_Status {
  Approved = 'APPROVED',
  Completed = 'COMPLETED',
  Canceled = 'CANCELED',
  Failed = 'FAILED'
}

export enum Enum_Payment_Source_Type {
  Card = 'CARD'
}

export type PaymentConnection = {
  __typename?: 'PaymentConnection';
  values?: Maybe<Array<Maybe<Payment>>>;
  groupBy?: Maybe<PaymentGroupBy>;
  aggregate?: Maybe<PaymentAggregator>;
};

export type PaymentGroupBy = {
  __typename?: 'PaymentGroupBy';
  id?: Maybe<Array<Maybe<PaymentConnectionId>>>;
  _id?: Maybe<Array<Maybe<PaymentConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<PaymentConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<PaymentConnectionUpdatedAt>>>;
  square_id?: Maybe<Array<Maybe<PaymentConnectionSquare_Id>>>;
  amount_money?: Maybe<Array<Maybe<PaymentConnectionAmount_Money>>>;
  tip_money?: Maybe<Array<Maybe<PaymentConnectionTip_Money>>>;
  total_money?: Maybe<Array<Maybe<PaymentConnectionTotal_Money>>>;
  app_fee_money?: Maybe<Array<Maybe<PaymentConnectionApp_Fee_Money>>>;
  refunded_money?: Maybe<Array<Maybe<PaymentConnectionRefunded_Money>>>;
  status?: Maybe<Array<Maybe<PaymentConnectionStatus>>>;
  source_type?: Maybe<Array<Maybe<PaymentConnectionSource_Type>>>;
  location_id?: Maybe<Array<Maybe<PaymentConnectionLocation_Id>>>;
  order_id?: Maybe<Array<Maybe<PaymentConnectionOrder_Id>>>;
  reference_id?: Maybe<Array<Maybe<PaymentConnectionReference_Id>>>;
  customer_id?: Maybe<Array<Maybe<PaymentConnectionCustomer_Id>>>;
  buyer_email_address?: Maybe<Array<Maybe<PaymentConnectionBuyer_Email_Address>>>;
  note?: Maybe<Array<Maybe<PaymentConnectionNote>>>;
  receipt_number?: Maybe<Array<Maybe<PaymentConnectionReceipt_Number>>>;
  receipt_url?: Maybe<Array<Maybe<PaymentConnectionReceipt_Url>>>;
  created_by?: Maybe<Array<Maybe<PaymentConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<PaymentConnectionUpdated_By>>>;
};

export type PaymentConnectionId = {
  __typename?: 'PaymentConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnection_Id = {
  __typename?: 'PaymentConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionCreatedAt = {
  __typename?: 'PaymentConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionUpdatedAt = {
  __typename?: 'PaymentConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionSquare_Id = {
  __typename?: 'PaymentConnectionSquare_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionAmount_Money = {
  __typename?: 'PaymentConnectionAmount_money';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionTip_Money = {
  __typename?: 'PaymentConnectionTip_money';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionTotal_Money = {
  __typename?: 'PaymentConnectionTotal_money';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionApp_Fee_Money = {
  __typename?: 'PaymentConnectionApp_fee_money';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionRefunded_Money = {
  __typename?: 'PaymentConnectionRefunded_money';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionStatus = {
  __typename?: 'PaymentConnectionStatus';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionSource_Type = {
  __typename?: 'PaymentConnectionSource_type';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionLocation_Id = {
  __typename?: 'PaymentConnectionLocation_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionOrder_Id = {
  __typename?: 'PaymentConnectionOrder_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionReference_Id = {
  __typename?: 'PaymentConnectionReference_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionCustomer_Id = {
  __typename?: 'PaymentConnectionCustomer_id';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionBuyer_Email_Address = {
  __typename?: 'PaymentConnectionBuyer_email_address';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionNote = {
  __typename?: 'PaymentConnectionNote';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionReceipt_Number = {
  __typename?: 'PaymentConnectionReceipt_number';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionReceipt_Url = {
  __typename?: 'PaymentConnectionReceipt_url';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionCreated_By = {
  __typename?: 'PaymentConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentConnectionUpdated_By = {
  __typename?: 'PaymentConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<PaymentConnection>;
};

export type PaymentAggregator = {
  __typename?: 'PaymentAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  related?: Maybe<Array<Maybe<Morph>>>;
};


export type UploadFileRelatedArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type Morph = TimeSlotAvailability | Error | CreateOrderResponse | UpdateOrderResponse | CreateOrderAndPayResponse | UsersPermissionsMe | UsersPermissionsMeRole | UsersPermissionsLoginPayload | UserPermissionsPasswordPayload | CheckIfUsernameAvailableResponse | UserContactInfo | LoginUserPayloadEnhanced | LoginPayloadEnhanced | CatalogCategory | CatalogCategoryConnection | CatalogCategoryAggregator | CatalogCategoryAggregatorSum | CatalogCategoryAggregatorAvg | CatalogCategoryAggregatorMin | CatalogCategoryAggregatorMax | CatalogCategoryGroupBy | CatalogCategoryConnectionId | CatalogCategoryConnection_Id | CatalogCategoryConnectionCreatedAt | CatalogCategoryConnectionUpdatedAt | CatalogCategoryConnectionSquare_Id | CatalogCategoryConnectionName | CatalogCategoryConnectionMeta | CatalogCategoryConnectionOrdinal | CatalogCategoryConnectionAvailable_On_Joo | CatalogCategoryConnectionCreated_By | CatalogCategoryConnectionUpdated_By | CreateCatalogCategoryPayload | UpdateCatalogCategoryPayload | DeleteCatalogCategoryPayload | CatalogImage | CatalogImageConnection | CatalogImageAggregator | CatalogImageGroupBy | CatalogImageConnectionId | CatalogImageConnection_Id | CatalogImageConnectionCreatedAt | CatalogImageConnectionUpdatedAt | CatalogImageConnectionSquare_Id | CatalogImageConnectionName | CatalogImageConnectionUrl | CatalogImageConnectionCaption | CatalogImageConnectionMeta | CatalogImageConnectionCreated_By | CatalogImageConnectionUpdated_By | CreateCatalogImagePayload | UpdateCatalogImagePayload | DeleteCatalogImagePayload | CatalogItemVariation | CatalogItemVariationConnection | CatalogItemVariationAggregator | CatalogItemVariationAggregatorSum | CatalogItemVariationAggregatorAvg | CatalogItemVariationAggregatorMin | CatalogItemVariationAggregatorMax | CatalogItemVariationGroupBy | CatalogItemVariationConnectionId | CatalogItemVariationConnection_Id | CatalogItemVariationConnectionCreatedAt | CatalogItemVariationConnectionUpdatedAt | CatalogItemVariationConnectionSquare_Id | CatalogItemVariationConnectionItem_Id | CatalogItemVariationConnectionName | CatalogItemVariationConnectionOrdinal | CatalogItemVariationConnectionPricing_Type | CatalogItemVariationConnectionPrice_Money | CatalogItemVariationConnectionMeta | CatalogItemVariationConnectionItem | CatalogItemVariationConnectionCreated_By | CatalogItemVariationConnectionUpdated_By | CreateCatalogItemVariationPayload | UpdateCatalogItemVariationPayload | DeleteCatalogItemVariationPayload | CatalogItem | CatalogItemConnection | CatalogItemAggregator | CatalogItemGroupBy | CatalogItemConnectionId | CatalogItemConnection_Id | CatalogItemConnectionCreatedAt | CatalogItemConnectionUpdatedAt | CatalogItemConnectionSquare_Id | CatalogItemConnectionName | CatalogItemConnectionDescription | CatalogItemConnectionAbbreviation | CatalogItemConnectionAvailable_For_Pickup | CatalogItemConnectionCategory_Id | CatalogItemConnectionProduct_Type | CatalogItemConnectionMeta | CatalogItemConnectionCategory | CatalogItemConnectionVariation_Square_Ids | CatalogItemConnectionTax_Ids | CatalogItemConnectionAvailable_On_Joo | CatalogItemConnectionCreated_By | CatalogItemConnectionUpdated_By | CreateCatalogItemPayload | UpdateCatalogItemPayload | DeleteCatalogItemPayload | CatalogModifierList | CatalogModifierListConnection | CatalogModifierListAggregator | CatalogModifierListAggregatorSum | CatalogModifierListAggregatorAvg | CatalogModifierListAggregatorMin | CatalogModifierListAggregatorMax | CatalogModifierListGroupBy | CatalogModifierListConnectionId | CatalogModifierListConnection_Id | CatalogModifierListConnectionCreatedAt | CatalogModifierListConnectionUpdatedAt | CatalogModifierListConnectionName | CatalogModifierListConnectionOrdinal | CatalogModifierListConnectionSelection_Type | CatalogModifierListConnectionMeta | CatalogModifierListConnectionModifiers_Square_Ids | CatalogModifierListConnectionSquare_Id | CatalogModifierListConnectionCreated_By | CatalogModifierListConnectionUpdated_By | CreateCatalogModifierListPayload | UpdateCatalogModifierListPayload | DeleteCatalogModifierListPayload | CatalogModifier | CatalogModifierConnection | CatalogModifierAggregator | CatalogModifierAggregatorSum | CatalogModifierAggregatorAvg | CatalogModifierAggregatorMin | CatalogModifierAggregatorMax | CatalogModifierGroupBy | CatalogModifierConnectionId | CatalogModifierConnection_Id | CatalogModifierConnectionCreatedAt | CatalogModifierConnectionUpdatedAt | CatalogModifierConnectionSquare_Id | CatalogModifierConnectionName | CatalogModifierConnectionPrice_Money | CatalogModifierConnectionOrdinal | CatalogModifierConnectionModifier_List_Id | CatalogModifierConnectionMeta | CatalogModifierConnectionModifier_List | CatalogModifierConnectionCreated_By | CatalogModifierConnectionUpdated_By | CreateCatalogModifierPayload | UpdateCatalogModifierPayload | DeleteCatalogModifierPayload | CatalogTax | CatalogTaxConnection | CatalogTaxAggregator | CatalogTaxAggregatorSum | CatalogTaxAggregatorAvg | CatalogTaxAggregatorMin | CatalogTaxAggregatorMax | CatalogTaxGroupBy | CatalogTaxConnectionId | CatalogTaxConnection_Id | CatalogTaxConnectionCreatedAt | CatalogTaxConnectionUpdatedAt | CatalogTaxConnectionSquare_Id | CatalogTaxConnectionName | CatalogTaxConnectionCalculation_Phase | CatalogTaxConnectionInclusion_Type | CatalogTaxConnectionPercentage | CatalogTaxConnectionApplies_To_Custom_Amounts | CatalogTaxConnectionEnabled | CatalogTaxConnectionMeta | CatalogTaxConnectionCreated_By | CatalogTaxConnectionUpdated_By | CreateCatalogTaxPayload | UpdateCatalogTaxPayload | DeleteCatalogTaxPayload | JooAdmin | UpdateJooAdminPayload | DeleteJooAdminPayload | Location | LocationConnection | LocationAggregator | LocationAggregatorSum | LocationAggregatorAvg | LocationAggregatorMin | LocationAggregatorMax | LocationGroupBy | LocationConnectionId | LocationConnection_Id | LocationConnectionCreatedAt | LocationConnectionUpdatedAt | LocationConnectionSquare_Id | LocationConnectionAddress | LocationConnectionBusiness_Email | LocationConnectionBusiness_Hours | LocationConnectionBusiness_Name | LocationConnectionCountry | LocationConnectionDescription | LocationConnectionName | LocationConnectionPhone_Number | LocationConnectionStatus | LocationConnectionWebsite_Url | LocationConnectionCoordinates | LocationConnectionTimezone | LocationConnectionLead_Time | LocationConnectionTime_Slot_Increment | LocationConnectionDefault_Max_Orders_Per_Time_Slot | LocationConnectionCreated_By | LocationConnectionUpdated_By | CreateLocationPayload | UpdateLocationPayload | DeleteLocationPayload | Order | OrderConnection | OrderAggregator | OrderAggregatorSum | OrderAggregatorAvg | OrderAggregatorMin | OrderAggregatorMax | OrderGroupBy | OrderConnectionId | OrderConnection_Id | OrderConnectionCreatedAt | OrderConnectionUpdatedAt | OrderConnectionSquare_Id | OrderConnectionLocation_Id | OrderConnectionCustomer_Id | OrderConnectionCreated_At | OrderConnectionUpdated_At | OrderConnectionClosed_At | OrderConnectionState | OrderConnectionVersion | OrderConnectionTotal_Money | OrderConnectionTotal_Tax_Money | OrderConnectionTotal_Discount_Money | OrderConnectionReceipt_Url | OrderConnectionReceipt_Number | OrderConnectionTotal_Tip_Money | OrderConnectionCurrent_Pickup_At | OrderConnectionCreated_By | OrderConnectionUpdated_By | CreateOrderPayload | UpdateOrderPayload | DeleteOrderPayload | Payment | PaymentConnection | PaymentAggregator | PaymentGroupBy | PaymentConnectionId | PaymentConnection_Id | PaymentConnectionCreatedAt | PaymentConnectionUpdatedAt | PaymentConnectionSquare_Id | PaymentConnectionAmount_Money | PaymentConnectionTip_Money | PaymentConnectionTotal_Money | PaymentConnectionApp_Fee_Money | PaymentConnectionRefunded_Money | PaymentConnectionStatus | PaymentConnectionSource_Type | PaymentConnectionLocation_Id | PaymentConnectionOrder_Id | PaymentConnectionReference_Id | PaymentConnectionCustomer_Id | PaymentConnectionBuyer_Email_Address | PaymentConnectionNote | PaymentConnectionReceipt_Number | PaymentConnectionReceipt_Url | PaymentConnectionCreated_By | PaymentConnectionUpdated_By | CreatePaymentPayload | UpdatePaymentPayload | DeletePaymentPayload | UploadFile | UploadFileConnection | UploadFileAggregator | UploadFileAggregatorSum | UploadFileAggregatorAvg | UploadFileAggregatorMin | UploadFileAggregatorMax | UploadFileGroupBy | UploadFileConnectionId | UploadFileConnection_Id | UploadFileConnectionCreatedAt | UploadFileConnectionUpdatedAt | UploadFileConnectionName | UploadFileConnectionAlternativeText | UploadFileConnectionCaption | UploadFileConnectionWidth | UploadFileConnectionHeight | UploadFileConnectionFormats | UploadFileConnectionHash | UploadFileConnectionExt | UploadFileConnectionMime | UploadFileConnectionSize | UploadFileConnectionUrl | UploadFileConnectionPreviewUrl | UploadFileConnectionProvider | UploadFileConnectionProvider_Metadata | UploadFileConnectionCreated_By | UploadFileConnectionUpdated_By | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsRoleConnection | UsersPermissionsRoleAggregator | UsersPermissionsRoleGroupBy | UsersPermissionsRoleConnectionId | UsersPermissionsRoleConnection_Id | UsersPermissionsRoleConnectionCreatedAt | UsersPermissionsRoleConnectionUpdatedAt | UsersPermissionsRoleConnectionName | UsersPermissionsRoleConnectionDescription | UsersPermissionsRoleConnectionType | UsersPermissionsRoleConnectionCreated_By | UsersPermissionsRoleConnectionUpdated_By | CreateRolePayload | UpdateRolePayload | DeleteRolePayload | UsersPermissionsUser | UsersPermissionsUserConnection | UsersPermissionsUserAggregator | UsersPermissionsUserGroupBy | UsersPermissionsUserConnectionId | UsersPermissionsUserConnection_Id | UsersPermissionsUserConnectionCreatedAt | UsersPermissionsUserConnectionUpdatedAt | UsersPermissionsUserConnectionUsername | UsersPermissionsUserConnectionEmail | UsersPermissionsUserConnectionProvider | UsersPermissionsUserConnectionConfirmed | UsersPermissionsUserConnectionBlocked | UsersPermissionsUserConnectionRole | UsersPermissionsUserConnectionFirstName | UsersPermissionsUserConnectionLastName | UsersPermissionsUserConnectionPhoneNumber | UsersPermissionsUserConnectionCreated_By | UsersPermissionsUserConnectionUpdated_By | CreateUserPayload | UpdateUserPayload | DeleteUserPayload | ComponentAddressAddress | ComponentAddressBusinessHours | ComponentAddressCoordinates | ComponentCatalogModifierListInfo | ComponentCatalogModifierOverrides | ComponentCatalogObjectMeta | ComponentMoneyPriceMoney | ComponentMoneyProcessingFee | ComponentOrderFulfillmentPickupDetails | ComponentOrderFulfillment | ComponentOrderLineItem | ComponentOrderOrderLineItemModifier | ComponentTimeOrderPacing | ComponentTimePeriods;

export type TimeSlotAvailability = {
  __typename?: 'TimeSlotAvailability';
  available: Scalars['Boolean'];
  timeSlot: Scalars['String'];
};

export type Error = {
  __typename?: 'Error';
  category: Scalars['String'];
  code: Scalars['String'];
  detail?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
};

export type CreateOrderResponse = {
  __typename?: 'CreateOrderResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  order?: Maybe<Order>;
};

export type UpdateOrderResponse = {
  __typename?: 'updateOrderResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  order?: Maybe<Order>;
};

export type CreateOrderAndPayResponse = {
  __typename?: 'CreateOrderAndPayResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  payment?: Maybe<Payment>;
  order?: Maybe<Order>;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  id: Scalars['ID'];
  username: Scalars['String'];
  email: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: UsersPermissionsMe;
};

export type UserPermissionsPasswordPayload = {
  __typename?: 'UserPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type CheckIfUsernameAvailableResponse = {
  __typename?: 'CheckIfUsernameAvailableResponse';
  taken: Scalars['Boolean'];
  username: Scalars['String'];
};

export type UserContactInfo = {
  __typename?: 'UserContactInfo';
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type LoginUserPayloadEnhanced = {
  __typename?: 'LoginUserPayloadEnhanced';
  id: Scalars['ID'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsMeRole>;
};

export type LoginPayloadEnhanced = {
  __typename?: 'LoginPayloadEnhanced';
  jwt?: Maybe<Scalars['String']>;
  user: LoginUserPayloadEnhanced;
};

export type CreateCatalogCategoryPayload = {
  __typename?: 'createCatalogCategoryPayload';
  catalogCategory?: Maybe<CatalogCategory>;
};

export type UpdateCatalogCategoryPayload = {
  __typename?: 'updateCatalogCategoryPayload';
  catalogCategory?: Maybe<CatalogCategory>;
};

export type DeleteCatalogCategoryPayload = {
  __typename?: 'deleteCatalogCategoryPayload';
  catalogCategory?: Maybe<CatalogCategory>;
};

export type CreateCatalogImagePayload = {
  __typename?: 'createCatalogImagePayload';
  catalogImage?: Maybe<CatalogImage>;
};

export type UpdateCatalogImagePayload = {
  __typename?: 'updateCatalogImagePayload';
  catalogImage?: Maybe<CatalogImage>;
};

export type DeleteCatalogImagePayload = {
  __typename?: 'deleteCatalogImagePayload';
  catalogImage?: Maybe<CatalogImage>;
};

export type CreateCatalogItemVariationPayload = {
  __typename?: 'createCatalogItemVariationPayload';
  catalogItemVariation?: Maybe<CatalogItemVariation>;
};

export type UpdateCatalogItemVariationPayload = {
  __typename?: 'updateCatalogItemVariationPayload';
  catalogItemVariation?: Maybe<CatalogItemVariation>;
};

export type DeleteCatalogItemVariationPayload = {
  __typename?: 'deleteCatalogItemVariationPayload';
  catalogItemVariation?: Maybe<CatalogItemVariation>;
};

export type CreateCatalogItemPayload = {
  __typename?: 'createCatalogItemPayload';
  catalogItem?: Maybe<CatalogItem>;
};

export type UpdateCatalogItemPayload = {
  __typename?: 'updateCatalogItemPayload';
  catalogItem?: Maybe<CatalogItem>;
};

export type DeleteCatalogItemPayload = {
  __typename?: 'deleteCatalogItemPayload';
  catalogItem?: Maybe<CatalogItem>;
};

export type CreateCatalogModifierListPayload = {
  __typename?: 'createCatalogModifierListPayload';
  catalogModifierList?: Maybe<CatalogModifierList>;
};

export type UpdateCatalogModifierListPayload = {
  __typename?: 'updateCatalogModifierListPayload';
  catalogModifierList?: Maybe<CatalogModifierList>;
};

export type DeleteCatalogModifierListPayload = {
  __typename?: 'deleteCatalogModifierListPayload';
  catalogModifierList?: Maybe<CatalogModifierList>;
};

export type CreateCatalogModifierPayload = {
  __typename?: 'createCatalogModifierPayload';
  catalogModifier?: Maybe<CatalogModifier>;
};

export type UpdateCatalogModifierPayload = {
  __typename?: 'updateCatalogModifierPayload';
  catalogModifier?: Maybe<CatalogModifier>;
};

export type DeleteCatalogModifierPayload = {
  __typename?: 'deleteCatalogModifierPayload';
  catalogModifier?: Maybe<CatalogModifier>;
};

export type CreateCatalogTaxPayload = {
  __typename?: 'createCatalogTaxPayload';
  catalogTax?: Maybe<CatalogTax>;
};

export type UpdateCatalogTaxPayload = {
  __typename?: 'updateCatalogTaxPayload';
  catalogTax?: Maybe<CatalogTax>;
};

export type DeleteCatalogTaxPayload = {
  __typename?: 'deleteCatalogTaxPayload';
  catalogTax?: Maybe<CatalogTax>;
};

export type UpdateJooAdminPayload = {
  __typename?: 'updateJooAdminPayload';
  jooAdmin?: Maybe<JooAdmin>;
};

export type DeleteJooAdminPayload = {
  __typename?: 'deleteJooAdminPayload';
  jooAdmin?: Maybe<JooAdmin>;
};

export type CreateLocationPayload = {
  __typename?: 'createLocationPayload';
  location?: Maybe<Location>;
};

export type UpdateLocationPayload = {
  __typename?: 'updateLocationPayload';
  location?: Maybe<Location>;
};

export type DeleteLocationPayload = {
  __typename?: 'deleteLocationPayload';
  location?: Maybe<Location>;
};

export type CreateOrderPayload = {
  __typename?: 'createOrderPayload';
  order?: Maybe<Order>;
};

export type UpdateOrderPayload = {
  __typename?: 'updateOrderPayload';
  order?: Maybe<Order>;
};

export type DeleteOrderPayload = {
  __typename?: 'deleteOrderPayload';
  order?: Maybe<Order>;
};

export type CreatePaymentPayload = {
  __typename?: 'createPaymentPayload';
  payment?: Maybe<Payment>;
};

export type UpdatePaymentPayload = {
  __typename?: 'updatePaymentPayload';
  payment?: Maybe<Payment>;
};

export type DeletePaymentPayload = {
  __typename?: 'deletePaymentPayload';
  payment?: Maybe<Payment>;
};

export type UploadFileConnection = {
  __typename?: 'UploadFileConnection';
  values?: Maybe<Array<Maybe<UploadFile>>>;
  groupBy?: Maybe<UploadFileGroupBy>;
  aggregate?: Maybe<UploadFileAggregator>;
};

export type UploadFileGroupBy = {
  __typename?: 'UploadFileGroupBy';
  id?: Maybe<Array<Maybe<UploadFileConnectionId>>>;
  _id?: Maybe<Array<Maybe<UploadFileConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<UploadFileConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<UploadFileConnectionUpdatedAt>>>;
  name?: Maybe<Array<Maybe<UploadFileConnectionName>>>;
  alternativeText?: Maybe<Array<Maybe<UploadFileConnectionAlternativeText>>>;
  caption?: Maybe<Array<Maybe<UploadFileConnectionCaption>>>;
  width?: Maybe<Array<Maybe<UploadFileConnectionWidth>>>;
  height?: Maybe<Array<Maybe<UploadFileConnectionHeight>>>;
  formats?: Maybe<Array<Maybe<UploadFileConnectionFormats>>>;
  hash?: Maybe<Array<Maybe<UploadFileConnectionHash>>>;
  ext?: Maybe<Array<Maybe<UploadFileConnectionExt>>>;
  mime?: Maybe<Array<Maybe<UploadFileConnectionMime>>>;
  size?: Maybe<Array<Maybe<UploadFileConnectionSize>>>;
  url?: Maybe<Array<Maybe<UploadFileConnectionUrl>>>;
  previewUrl?: Maybe<Array<Maybe<UploadFileConnectionPreviewUrl>>>;
  provider?: Maybe<Array<Maybe<UploadFileConnectionProvider>>>;
  provider_metadata?: Maybe<Array<Maybe<UploadFileConnectionProvider_Metadata>>>;
  created_by?: Maybe<Array<Maybe<UploadFileConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<UploadFileConnectionUpdated_By>>>;
};

export type UploadFileConnectionId = {
  __typename?: 'UploadFileConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnection_Id = {
  __typename?: 'UploadFileConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreatedAt = {
  __typename?: 'UploadFileConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdatedAt = {
  __typename?: 'UploadFileConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionName = {
  __typename?: 'UploadFileConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionAlternativeText = {
  __typename?: 'UploadFileConnectionAlternativeText';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCaption = {
  __typename?: 'UploadFileConnectionCaption';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionWidth = {
  __typename?: 'UploadFileConnectionWidth';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHeight = {
  __typename?: 'UploadFileConnectionHeight';
  key?: Maybe<Scalars['Int']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionFormats = {
  __typename?: 'UploadFileConnectionFormats';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionHash = {
  __typename?: 'UploadFileConnectionHash';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionExt = {
  __typename?: 'UploadFileConnectionExt';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionMime = {
  __typename?: 'UploadFileConnectionMime';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionSize = {
  __typename?: 'UploadFileConnectionSize';
  key?: Maybe<Scalars['Float']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUrl = {
  __typename?: 'UploadFileConnectionUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionPreviewUrl = {
  __typename?: 'UploadFileConnectionPreviewUrl';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider = {
  __typename?: 'UploadFileConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionProvider_Metadata = {
  __typename?: 'UploadFileConnectionProvider_metadata';
  key?: Maybe<Scalars['JSON']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionCreated_By = {
  __typename?: 'UploadFileConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileConnectionUpdated_By = {
  __typename?: 'UploadFileConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UploadFileConnection>;
};

export type UploadFileAggregator = {
  __typename?: 'UploadFileAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
  sum?: Maybe<UploadFileAggregatorSum>;
  avg?: Maybe<UploadFileAggregatorAvg>;
  min?: Maybe<UploadFileAggregatorMin>;
  max?: Maybe<UploadFileAggregatorMax>;
};

export type UploadFileAggregatorSum = {
  __typename?: 'UploadFileAggregatorSum';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorAvg = {
  __typename?: 'UploadFileAggregatorAvg';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMin = {
  __typename?: 'UploadFileAggregatorMin';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UploadFileAggregatorMax = {
  __typename?: 'UploadFileAggregatorMax';
  width?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: Scalars['String'];
  controller: Scalars['String'];
  action: Scalars['String'];
  enabled: Scalars['Boolean'];
  policy?: Maybe<Scalars['String']>;
  role?: Maybe<UsersPermissionsRole>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
  permissions?: Maybe<Array<Maybe<UsersPermissionsPermission>>>;
  users?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
};


export type UsersPermissionsRolePermissionsArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};


export type UsersPermissionsRoleUsersArgs = {
  sort?: Maybe<Scalars['String']>;
  limit?: Maybe<Scalars['Int']>;
  start?: Maybe<Scalars['Int']>;
  where?: Maybe<Scalars['JSON']>;
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  id: Scalars['ID'];
  _id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<UsersPermissionsRole>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  created_by?: Maybe<AdminUser>;
  updated_by?: Maybe<AdminUser>;
};

export type UsersPermissionsRoleConnection = {
  __typename?: 'UsersPermissionsRoleConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsRole>>>;
  groupBy?: Maybe<UsersPermissionsRoleGroupBy>;
  aggregate?: Maybe<UsersPermissionsRoleAggregator>;
};

export type UsersPermissionsRoleGroupBy = {
  __typename?: 'UsersPermissionsRoleGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionId>>>;
  _id?: Maybe<Array<Maybe<UsersPermissionsRoleConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionUpdatedAt>>>;
  name?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionName>>>;
  description?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionDescription>>>;
  type?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionType>>>;
  created_by?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<UsersPermissionsRoleConnectionUpdated_By>>>;
};

export type UsersPermissionsRoleConnectionId = {
  __typename?: 'UsersPermissionsRoleConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnection_Id = {
  __typename?: 'UsersPermissionsRoleConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionCreatedAt = {
  __typename?: 'UsersPermissionsRoleConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionUpdatedAt = {
  __typename?: 'UsersPermissionsRoleConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionName = {
  __typename?: 'UsersPermissionsRoleConnectionName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionDescription = {
  __typename?: 'UsersPermissionsRoleConnectionDescription';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionType = {
  __typename?: 'UsersPermissionsRoleConnectionType';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionCreated_By = {
  __typename?: 'UsersPermissionsRoleConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleConnectionUpdated_By = {
  __typename?: 'UsersPermissionsRoleConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsRoleConnection>;
};

export type UsersPermissionsRoleAggregator = {
  __typename?: 'UsersPermissionsRoleAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateRolePayload = {
  __typename?: 'createRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UpdateRolePayload = {
  __typename?: 'updateRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type DeleteRolePayload = {
  __typename?: 'deleteRolePayload';
  role?: Maybe<UsersPermissionsRole>;
};

export type UsersPermissionsUserConnection = {
  __typename?: 'UsersPermissionsUserConnection';
  values?: Maybe<Array<Maybe<UsersPermissionsUser>>>;
  groupBy?: Maybe<UsersPermissionsUserGroupBy>;
  aggregate?: Maybe<UsersPermissionsUserAggregator>;
};

export type UsersPermissionsUserGroupBy = {
  __typename?: 'UsersPermissionsUserGroupBy';
  id?: Maybe<Array<Maybe<UsersPermissionsUserConnectionId>>>;
  _id?: Maybe<Array<Maybe<UsersPermissionsUserConnection_Id>>>;
  createdAt?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreatedAt>>>;
  updatedAt?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdatedAt>>>;
  username?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUsername>>>;
  email?: Maybe<Array<Maybe<UsersPermissionsUserConnectionEmail>>>;
  provider?: Maybe<Array<Maybe<UsersPermissionsUserConnectionProvider>>>;
  confirmed?: Maybe<Array<Maybe<UsersPermissionsUserConnectionConfirmed>>>;
  blocked?: Maybe<Array<Maybe<UsersPermissionsUserConnectionBlocked>>>;
  role?: Maybe<Array<Maybe<UsersPermissionsUserConnectionRole>>>;
  firstName?: Maybe<Array<Maybe<UsersPermissionsUserConnectionFirstName>>>;
  lastName?: Maybe<Array<Maybe<UsersPermissionsUserConnectionLastName>>>;
  phoneNumber?: Maybe<Array<Maybe<UsersPermissionsUserConnectionPhoneNumber>>>;
  created_by?: Maybe<Array<Maybe<UsersPermissionsUserConnectionCreated_By>>>;
  updated_by?: Maybe<Array<Maybe<UsersPermissionsUserConnectionUpdated_By>>>;
};

export type UsersPermissionsUserConnectionId = {
  __typename?: 'UsersPermissionsUserConnectionId';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnection_Id = {
  __typename?: 'UsersPermissionsUserConnection_id';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreatedAt = {
  __typename?: 'UsersPermissionsUserConnectionCreatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdatedAt = {
  __typename?: 'UsersPermissionsUserConnectionUpdatedAt';
  key?: Maybe<Scalars['DateTime']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUsername = {
  __typename?: 'UsersPermissionsUserConnectionUsername';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionEmail = {
  __typename?: 'UsersPermissionsUserConnectionEmail';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionProvider = {
  __typename?: 'UsersPermissionsUserConnectionProvider';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionConfirmed = {
  __typename?: 'UsersPermissionsUserConnectionConfirmed';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionBlocked = {
  __typename?: 'UsersPermissionsUserConnectionBlocked';
  key?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionRole = {
  __typename?: 'UsersPermissionsUserConnectionRole';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionFirstName = {
  __typename?: 'UsersPermissionsUserConnectionFirstName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionLastName = {
  __typename?: 'UsersPermissionsUserConnectionLastName';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionPhoneNumber = {
  __typename?: 'UsersPermissionsUserConnectionPhoneNumber';
  key?: Maybe<Scalars['String']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionCreated_By = {
  __typename?: 'UsersPermissionsUserConnectionCreated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserConnectionUpdated_By = {
  __typename?: 'UsersPermissionsUserConnectionUpdated_by';
  key?: Maybe<Scalars['ID']>;
  connection?: Maybe<UsersPermissionsUserConnection>;
};

export type UsersPermissionsUserAggregator = {
  __typename?: 'UsersPermissionsUserAggregator';
  count?: Maybe<Scalars['Int']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  user?: Maybe<UsersPermissionsUser>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createCatalogCategory?: Maybe<CreateCatalogCategoryPayload>;
  updateCatalogCategory?: Maybe<UpdateCatalogCategoryPayload>;
  deleteCatalogCategory?: Maybe<DeleteCatalogCategoryPayload>;
  createCatalogImage?: Maybe<CreateCatalogImagePayload>;
  updateCatalogImage?: Maybe<UpdateCatalogImagePayload>;
  deleteCatalogImage?: Maybe<DeleteCatalogImagePayload>;
  createCatalogItemVariation?: Maybe<CreateCatalogItemVariationPayload>;
  updateCatalogItemVariation?: Maybe<UpdateCatalogItemVariationPayload>;
  deleteCatalogItemVariation?: Maybe<DeleteCatalogItemVariationPayload>;
  createCatalogItem?: Maybe<CreateCatalogItemPayload>;
  updateCatalogItem?: Maybe<UpdateCatalogItemPayload>;
  deleteCatalogItem?: Maybe<DeleteCatalogItemPayload>;
  createCatalogModifierList?: Maybe<CreateCatalogModifierListPayload>;
  updateCatalogModifierList?: Maybe<UpdateCatalogModifierListPayload>;
  deleteCatalogModifierList?: Maybe<DeleteCatalogModifierListPayload>;
  createCatalogModifier?: Maybe<CreateCatalogModifierPayload>;
  updateCatalogModifier?: Maybe<UpdateCatalogModifierPayload>;
  deleteCatalogModifier?: Maybe<DeleteCatalogModifierPayload>;
  createCatalogTax?: Maybe<CreateCatalogTaxPayload>;
  updateCatalogTax?: Maybe<UpdateCatalogTaxPayload>;
  deleteCatalogTax?: Maybe<DeleteCatalogTaxPayload>;
  updateJooAdmin?: Maybe<UpdateJooAdminPayload>;
  deleteJooAdmin?: Maybe<DeleteJooAdminPayload>;
  createLocation?: Maybe<CreateLocationPayload>;
  updateLocation?: Maybe<UpdateLocationPayload>;
  deleteLocation?: Maybe<DeleteLocationPayload>;
  createOrder?: Maybe<CreateOrderPayload>;
  updateOrder?: Maybe<UpdateOrderPayload>;
  deleteOrder?: Maybe<DeleteOrderPayload>;
  createPayment?: Maybe<CreatePaymentPayload>;
  updatePayment?: Maybe<UpdatePaymentPayload>;
  deletePayment?: Maybe<DeletePaymentPayload>;
  /** Create a new role */
  createRole?: Maybe<CreateRolePayload>;
  /** Update an existing role */
  updateRole?: Maybe<UpdateRolePayload>;
  /** Delete an existing role */
  deleteRole?: Maybe<DeleteRolePayload>;
  /** Create a new user */
  createUser?: Maybe<CreateUserPayload>;
  /** Update an existing user */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Delete an existing user */
  deleteUser?: Maybe<DeleteUserPayload>;
  calculateOrder: CreateOrderResponse;
  createOrderWithSquare: CreateOrderResponse;
  createOrderAndPay: CreateOrderAndPayResponse;
  updatePickupTime: UpdateOrderResponse;
  cancelOrder: UpdateOrderResponse;
  upload: UploadFile;
  multipleUpload: Array<Maybe<UploadFile>>;
  login: UsersPermissionsLoginPayload;
  register: UsersPermissionsLoginPayload;
  forgotPassword?: Maybe<UserPermissionsPasswordPayload>;
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  registerEnhanced: UsersPermissionsLoginPayload;
  loginEnhanced: LoginPayloadEnhanced;
  updateMyContactInfo: UserContactInfo;
};


export type MutationCreateCatalogCategoryArgs = {
  input?: Maybe<CreateCatalogCategoryInput>;
};


export type MutationUpdateCatalogCategoryArgs = {
  input?: Maybe<UpdateCatalogCategoryInput>;
};


export type MutationDeleteCatalogCategoryArgs = {
  input?: Maybe<DeleteCatalogCategoryInput>;
};


export type MutationCreateCatalogImageArgs = {
  input?: Maybe<CreateCatalogImageInput>;
};


export type MutationUpdateCatalogImageArgs = {
  input?: Maybe<UpdateCatalogImageInput>;
};


export type MutationDeleteCatalogImageArgs = {
  input?: Maybe<DeleteCatalogImageInput>;
};


export type MutationCreateCatalogItemVariationArgs = {
  input?: Maybe<CreateCatalogItemVariationInput>;
};


export type MutationUpdateCatalogItemVariationArgs = {
  input?: Maybe<UpdateCatalogItemVariationInput>;
};


export type MutationDeleteCatalogItemVariationArgs = {
  input?: Maybe<DeleteCatalogItemVariationInput>;
};


export type MutationCreateCatalogItemArgs = {
  input?: Maybe<CreateCatalogItemInput>;
};


export type MutationUpdateCatalogItemArgs = {
  input?: Maybe<UpdateCatalogItemInput>;
};


export type MutationDeleteCatalogItemArgs = {
  input?: Maybe<DeleteCatalogItemInput>;
};


export type MutationCreateCatalogModifierListArgs = {
  input?: Maybe<CreateCatalogModifierListInput>;
};


export type MutationUpdateCatalogModifierListArgs = {
  input?: Maybe<UpdateCatalogModifierListInput>;
};


export type MutationDeleteCatalogModifierListArgs = {
  input?: Maybe<DeleteCatalogModifierListInput>;
};


export type MutationCreateCatalogModifierArgs = {
  input?: Maybe<CreateCatalogModifierInput>;
};


export type MutationUpdateCatalogModifierArgs = {
  input?: Maybe<UpdateCatalogModifierInput>;
};


export type MutationDeleteCatalogModifierArgs = {
  input?: Maybe<DeleteCatalogModifierInput>;
};


export type MutationCreateCatalogTaxArgs = {
  input?: Maybe<CreateCatalogTaxInput>;
};


export type MutationUpdateCatalogTaxArgs = {
  input?: Maybe<UpdateCatalogTaxInput>;
};


export type MutationDeleteCatalogTaxArgs = {
  input?: Maybe<DeleteCatalogTaxInput>;
};


export type MutationUpdateJooAdminArgs = {
  input?: Maybe<UpdateJooAdminInput>;
};


export type MutationCreateLocationArgs = {
  input?: Maybe<CreateLocationInput>;
};


export type MutationUpdateLocationArgs = {
  input?: Maybe<UpdateLocationInput>;
};


export type MutationDeleteLocationArgs = {
  input?: Maybe<DeleteLocationInput>;
};


export type MutationCreateOrderArgs = {
  input?: Maybe<CreateOrderInput>;
};


export type MutationUpdateOrderArgs = {
  input?: Maybe<UpdateOrderInput>;
};


export type MutationDeleteOrderArgs = {
  input?: Maybe<DeleteOrderInput>;
};


export type MutationCreatePaymentArgs = {
  input?: Maybe<CreatePaymentInput>;
};


export type MutationUpdatePaymentArgs = {
  input?: Maybe<UpdatePaymentInput>;
};


export type MutationDeletePaymentArgs = {
  input?: Maybe<DeletePaymentInput>;
};


export type MutationCreateRoleArgs = {
  input?: Maybe<CreateRoleInput>;
};


export type MutationUpdateRoleArgs = {
  input?: Maybe<UpdateRoleInput>;
};


export type MutationDeleteRoleArgs = {
  input?: Maybe<DeleteRoleInput>;
};


export type MutationCreateUserArgs = {
  input?: Maybe<CreateUserInput>;
};


export type MutationUpdateUserArgs = {
  input?: Maybe<UpdateUserInput>;
};


export type MutationDeleteUserArgs = {
  input?: Maybe<DeleteUserInput>;
};


export type MutationCalculateOrderArgs = {
  input: OrderInput;
};


export type MutationCreateOrderWithSquareArgs = {
  input: OrderInput;
};


export type MutationCreateOrderAndPayArgs = {
  orderRequest: OrderInput;
  paymentRequest: CreatePaymentRequestInput;
  recipient: OrderFulfillmentRecipientInput;
  requestedPickupTime?: Maybe<Scalars['String']>;
  orderNote?: Maybe<Scalars['String']>;
};


export type MutationUpdatePickupTimeArgs = {
  jooOrderId: Scalars['String'];
  requestedPickupTime: Scalars['String'];
};


export type MutationCancelOrderArgs = {
  squareOrderId: Scalars['String'];
};


export type MutationUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  file: Scalars['Upload'];
};


export type MutationMultipleUploadArgs = {
  refId?: Maybe<Scalars['ID']>;
  ref?: Maybe<Scalars['String']>;
  field?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  files: Array<Maybe<Scalars['Upload']>>;
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  code: Scalars['String'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type MutationRegisterEnhancedArgs = {
  input: UsersPermissionsRegisterEnhancedInput;
};


export type MutationLoginEnhancedArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationUpdateMyContactInfoArgs = {
  input: UserContactUpdateInput;
};

export type CreateCatalogCategoryInput = {
  data?: Maybe<CatalogCategoryInput>;
};

export type CatalogCategoryInput = {
  square_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  meta?: Maybe<ComponentCatalogObjectMetaInput>;
  items?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ordinal?: Maybe<Scalars['Int']>;
  available_on_joo?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentCatalogObjectMetaInput = {
  type: Enum_Componentcatalogobjectmeta_Type;
  updated_at?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  present_at_all_locations?: Maybe<Scalars['Boolean']>;
  image_id?: Maybe<Scalars['String']>;
  present_at_locations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  absent_at_locations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  present_at_location_ids?: Maybe<Scalars['JSON']>;
  absent_at_location_ids?: Maybe<Scalars['JSON']>;
  image?: Maybe<Scalars['ID']>;
};

export type UpdateCatalogCategoryInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCatalogCategoryInput>;
};

export type InputId = {
  id: Scalars['ID'];
};

export type EditCatalogCategoryInput = {
  square_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  meta?: Maybe<EditComponentCatalogObjectMetaInput>;
  items?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ordinal?: Maybe<Scalars['Int']>;
  available_on_joo?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentCatalogObjectMetaInput = {
  id?: Maybe<Scalars['ID']>;
  type?: Maybe<Enum_Componentcatalogobjectmeta_Type>;
  updated_at?: Maybe<Scalars['DateTime']>;
  version?: Maybe<Scalars['Int']>;
  is_deleted?: Maybe<Scalars['Boolean']>;
  present_at_all_locations?: Maybe<Scalars['Boolean']>;
  image_id?: Maybe<Scalars['String']>;
  present_at_locations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  absent_at_locations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  present_at_location_ids?: Maybe<Scalars['JSON']>;
  absent_at_location_ids?: Maybe<Scalars['JSON']>;
  image?: Maybe<Scalars['ID']>;
};

export type DeleteCatalogCategoryInput = {
  where?: Maybe<InputId>;
};

export type CreateCatalogImageInput = {
  data?: Maybe<CatalogImageInput>;
};

export type CatalogImageInput = {
  square_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  meta?: Maybe<ComponentCatalogObjectMetaInput>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateCatalogImageInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCatalogImageInput>;
};

export type EditCatalogImageInput = {
  square_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  meta?: Maybe<EditComponentCatalogObjectMetaInput>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteCatalogImageInput = {
  where?: Maybe<InputId>;
};

export type CreateCatalogItemVariationInput = {
  data?: Maybe<CatalogItemVariationInput>;
};

export type CatalogItemVariationInput = {
  square_id: Scalars['String'];
  item_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  ordinal?: Maybe<Scalars['Int']>;
  pricing_type?: Maybe<Enum_Catalogitemvariation_Pricing_Type>;
  price_money?: Maybe<ComponentMoneyPriceMoneyInput>;
  sku?: Maybe<Scalars['String']>;
  meta?: Maybe<ComponentCatalogObjectMetaInput>;
  item?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentMoneyPriceMoneyInput = {
  amount: Scalars['Int'];
  currency?: Maybe<Scalars['String']>;
};

export type UpdateCatalogItemVariationInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCatalogItemVariationInput>;
};

export type EditCatalogItemVariationInput = {
  square_id?: Maybe<Scalars['String']>;
  item_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ordinal?: Maybe<Scalars['Int']>;
  pricing_type?: Maybe<Enum_Catalogitemvariation_Pricing_Type>;
  price_money?: Maybe<EditComponentMoneyPriceMoneyInput>;
  sku?: Maybe<Scalars['String']>;
  meta?: Maybe<EditComponentCatalogObjectMetaInput>;
  item?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentMoneyPriceMoneyInput = {
  id?: Maybe<Scalars['ID']>;
  amount?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
};

export type DeleteCatalogItemVariationInput = {
  where?: Maybe<InputId>;
};

export type CreateCatalogItemInput = {
  data?: Maybe<CatalogItemInput>;
};

export type CatalogItemInput = {
  square_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  abbreviation?: Maybe<Scalars['String']>;
  available_for_pickup?: Maybe<Scalars['Boolean']>;
  category_id?: Maybe<Scalars['String']>;
  product_type?: Maybe<Enum_Catalogitem_Product_Type>;
  variations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  meta?: Maybe<ComponentCatalogObjectMetaInput>;
  category?: Maybe<Scalars['ID']>;
  variation_square_ids?: Maybe<Scalars['JSON']>;
  modifier_list_info?: Maybe<Array<Maybe<ComponentCatalogModifierListInfoInput>>>;
  tax_ids?: Maybe<Scalars['JSON']>;
  taxes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  available_on_joo?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentCatalogModifierListInfoInput = {
  modifier_list?: Maybe<Scalars['ID']>;
  enabled?: Maybe<Scalars['Boolean']>;
  max_selected_modifiers?: Maybe<Scalars['Int']>;
  min_selected_modifiers?: Maybe<Scalars['Int']>;
  modifier_overrides?: Maybe<Array<Maybe<ComponentCatalogModifierOverrideInput>>>;
  modifier_list_id: Scalars['String'];
};

export type ComponentCatalogModifierOverrideInput = {
  modifier_id: Scalars['String'];
  on_by_default?: Maybe<Scalars['Boolean']>;
};

export type UpdateCatalogItemInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCatalogItemInput>;
};

export type EditCatalogItemInput = {
  square_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  abbreviation?: Maybe<Scalars['String']>;
  available_for_pickup?: Maybe<Scalars['Boolean']>;
  category_id?: Maybe<Scalars['String']>;
  product_type?: Maybe<Enum_Catalogitem_Product_Type>;
  variations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  meta?: Maybe<EditComponentCatalogObjectMetaInput>;
  category?: Maybe<Scalars['ID']>;
  variation_square_ids?: Maybe<Scalars['JSON']>;
  modifier_list_info?: Maybe<Array<Maybe<EditComponentCatalogModifierListInfoInput>>>;
  tax_ids?: Maybe<Scalars['JSON']>;
  taxes?: Maybe<Array<Maybe<Scalars['ID']>>>;
  available_on_joo?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentCatalogModifierListInfoInput = {
  id?: Maybe<Scalars['ID']>;
  modifier_list?: Maybe<Scalars['ID']>;
  enabled?: Maybe<Scalars['Boolean']>;
  max_selected_modifiers?: Maybe<Scalars['Int']>;
  min_selected_modifiers?: Maybe<Scalars['Int']>;
  modifier_overrides?: Maybe<Array<Maybe<EditComponentCatalogModifierOverrideInput>>>;
  modifier_list_id?: Maybe<Scalars['String']>;
};

export type EditComponentCatalogModifierOverrideInput = {
  id?: Maybe<Scalars['ID']>;
  modifier_id?: Maybe<Scalars['String']>;
  on_by_default?: Maybe<Scalars['Boolean']>;
};

export type DeleteCatalogItemInput = {
  where?: Maybe<InputId>;
};

export type CreateCatalogModifierListInput = {
  data?: Maybe<CatalogModifierListInput>;
};

export type CatalogModifierListInput = {
  name?: Maybe<Scalars['String']>;
  ordinal?: Maybe<Scalars['Int']>;
  selection_type?: Maybe<Enum_Catalogmodifierlist_Selection_Type>;
  meta?: Maybe<ComponentCatalogObjectMetaInput>;
  modifiers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  modifiers_square_ids?: Maybe<Scalars['JSON']>;
  square_id: Scalars['String'];
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateCatalogModifierListInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCatalogModifierListInput>;
};

export type EditCatalogModifierListInput = {
  name?: Maybe<Scalars['String']>;
  ordinal?: Maybe<Scalars['Int']>;
  selection_type?: Maybe<Enum_Catalogmodifierlist_Selection_Type>;
  meta?: Maybe<EditComponentCatalogObjectMetaInput>;
  modifiers?: Maybe<Array<Maybe<Scalars['ID']>>>;
  modifiers_square_ids?: Maybe<Scalars['JSON']>;
  square_id?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteCatalogModifierListInput = {
  where?: Maybe<InputId>;
};

export type CreateCatalogModifierInput = {
  data?: Maybe<CatalogModifierInput>;
};

export type CatalogModifierInput = {
  square_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  price_money?: Maybe<ComponentMoneyPriceMoneyInput>;
  ordinal?: Maybe<Scalars['Int']>;
  modifier_list_id: Scalars['String'];
  meta?: Maybe<ComponentCatalogObjectMetaInput>;
  modifier_list?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateCatalogModifierInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCatalogModifierInput>;
};

export type EditCatalogModifierInput = {
  square_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price_money?: Maybe<EditComponentMoneyPriceMoneyInput>;
  ordinal?: Maybe<Scalars['Int']>;
  modifier_list_id?: Maybe<Scalars['String']>;
  meta?: Maybe<EditComponentCatalogObjectMetaInput>;
  modifier_list?: Maybe<Scalars['ID']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteCatalogModifierInput = {
  where?: Maybe<InputId>;
};

export type CreateCatalogTaxInput = {
  data?: Maybe<CatalogTaxInput>;
};

export type CatalogTaxInput = {
  square_id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  calculation_phase?: Maybe<Enum_Catalogtax_Calculation_Phase>;
  inclusion_type?: Maybe<Enum_Catalogtax_Inclusion_Type>;
  percentage?: Maybe<Scalars['Float']>;
  applies_to_custom_amounts?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<ComponentCatalogObjectMetaInput>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateCatalogTaxInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditCatalogTaxInput>;
};

export type EditCatalogTaxInput = {
  square_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  calculation_phase?: Maybe<Enum_Catalogtax_Calculation_Phase>;
  inclusion_type?: Maybe<Enum_Catalogtax_Inclusion_Type>;
  percentage?: Maybe<Scalars['Float']>;
  applies_to_custom_amounts?: Maybe<Scalars['Boolean']>;
  enabled?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<EditComponentCatalogObjectMetaInput>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteCatalogTaxInput = {
  where?: Maybe<InputId>;
};

export type UpdateJooAdminInput = {
  data?: Maybe<EditJooAdminInput>;
};

export type EditJooAdminInput = {
  catalogSyncInProgress?: Maybe<Scalars['Boolean']>;
  catalogSyncRequested?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type CreateLocationInput = {
  data?: Maybe<LocationInput>;
};

export type LocationInput = {
  square_id: Scalars['String'];
  address?: Maybe<ComponentAddressAddressInput>;
  business_email?: Maybe<Scalars['String']>;
  business_hours?: Maybe<ComponentAddressBusinessHourInput>;
  business_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Location_Status>;
  website_url?: Maybe<Scalars['String']>;
  coordinates?: Maybe<ComponentAddressCoordinateInput>;
  timezone: Scalars['String'];
  lead_time?: Maybe<Scalars['Int']>;
  time_slot_increment?: Maybe<Scalars['Int']>;
  order_pacing?: Maybe<Array<Maybe<ComponentTimeOrderPacingInput>>>;
  default_max_orders_per_time_slot?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentAddressAddressInput = {
  postal_code?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  sublocality?: Maybe<Scalars['String']>;
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  address_line_3?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  administrative_district_level_1?: Maybe<Scalars['String']>;
  sublocality_2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  administrative_district_level_2?: Maybe<Scalars['String']>;
  sublocality_3?: Maybe<Scalars['String']>;
  administrative_district_level_3?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
};

export type ComponentAddressBusinessHourInput = {
  periods?: Maybe<Array<Maybe<ComponentTimePeriodInput>>>;
};

export type ComponentTimePeriodInput = {
  day_of_week: Enum_Componenttimeperiods_Day_Of_Week;
  end_local_time: Scalars['String'];
  start_local_time: Scalars['String'];
};

export type ComponentAddressCoordinateInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type ComponentTimeOrderPacingInput = {
  start: Scalars['Time'];
  end: Scalars['Time'];
  day_of_week: Enum_Componenttimeorderpacing_Day_Of_Week;
  max_orders_per_time_slot: Scalars['Int'];
};

export type UpdateLocationInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditLocationInput>;
};

export type EditLocationInput = {
  square_id?: Maybe<Scalars['String']>;
  address?: Maybe<EditComponentAddressAddressInput>;
  business_email?: Maybe<Scalars['String']>;
  business_hours?: Maybe<EditComponentAddressBusinessHourInput>;
  business_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  status?: Maybe<Enum_Location_Status>;
  website_url?: Maybe<Scalars['String']>;
  coordinates?: Maybe<EditComponentAddressCoordinateInput>;
  timezone?: Maybe<Scalars['String']>;
  lead_time?: Maybe<Scalars['Int']>;
  time_slot_increment?: Maybe<Scalars['Int']>;
  order_pacing?: Maybe<Array<Maybe<EditComponentTimeOrderPacingInput>>>;
  default_max_orders_per_time_slot?: Maybe<Scalars['Int']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentAddressAddressInput = {
  id?: Maybe<Scalars['ID']>;
  postal_code?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  sublocality?: Maybe<Scalars['String']>;
  address_line_1?: Maybe<Scalars['String']>;
  address_line_2?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['String']>;
  address_line_3?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  administrative_district_level_1?: Maybe<Scalars['String']>;
  sublocality_2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  administrative_district_level_2?: Maybe<Scalars['String']>;
  sublocality_3?: Maybe<Scalars['String']>;
  administrative_district_level_3?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
};

export type EditComponentAddressBusinessHourInput = {
  id?: Maybe<Scalars['ID']>;
  periods?: Maybe<Array<Maybe<EditComponentTimePeriodInput>>>;
};

export type EditComponentTimePeriodInput = {
  id?: Maybe<Scalars['ID']>;
  day_of_week?: Maybe<Enum_Componenttimeperiods_Day_Of_Week>;
  end_local_time?: Maybe<Scalars['String']>;
  start_local_time?: Maybe<Scalars['String']>;
};

export type EditComponentAddressCoordinateInput = {
  id?: Maybe<Scalars['ID']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
};

export type EditComponentTimeOrderPacingInput = {
  id?: Maybe<Scalars['ID']>;
  start?: Maybe<Scalars['Time']>;
  end?: Maybe<Scalars['Time']>;
  day_of_week?: Maybe<Enum_Componenttimeorderpacing_Day_Of_Week>;
  max_orders_per_time_slot?: Maybe<Scalars['Int']>;
};

export type DeleteLocationInput = {
  where?: Maybe<InputId>;
};

export type CreateOrderInput = {
  data?: Maybe<OrderInput>;
};

export type OrderInput = {
  square_id?: Maybe<Scalars['String']>;
  location_id: Scalars['String'];
  customer_id?: Maybe<Scalars['String']>;
  line_items?: Maybe<Array<Maybe<ComponentOrderLineItemInput>>>;
  fulfillments?: Maybe<Array<Maybe<ComponentOrderFulfillmentInput>>>;
  created_at?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  closed_at?: Maybe<Scalars['String']>;
  state?: Maybe<Enum_Order_State>;
  version?: Maybe<Scalars['Int']>;
  total_money?: Maybe<ComponentMoneyPriceMoneyInput>;
  total_tax_money?: Maybe<ComponentMoneyPriceMoneyInput>;
  total_discount_money?: Maybe<ComponentMoneyPriceMoneyInput>;
  receipt_url?: Maybe<Scalars['String']>;
  receipt_number?: Maybe<Scalars['String']>;
  total_tip_money?: Maybe<ComponentMoneyPriceMoneyInput>;
  current_pickup_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentOrderLineItemInput = {
  quantity: Scalars['String'];
  catalog_object_id: Scalars['String'];
  modifiers?: Maybe<Array<Maybe<ComponentOrderOrderLineItemModifierInput>>>;
  note?: Maybe<Scalars['String']>;
};

export type ComponentOrderOrderLineItemModifierInput = {
  catalog_object_id: Scalars['String'];
};

export type ComponentOrderFulfillmentInput = {
  pickup_details?: Maybe<ComponentOrderFulfillmentPickupDetailInput>;
  state?: Maybe<Enum_Componentorderfulfillment_State>;
  type?: Maybe<Enum_Componentorderfulfillment_Type>;
  uid?: Maybe<Scalars['String']>;
};

export type ComponentOrderFulfillmentPickupDetailInput = {
  pickup_window_duration?: Maybe<Scalars['String']>;
  schedule_type?: Maybe<Enum_Componentorderfulfillmentpickupdetails_Schedule_Type>;
  cancel_reason?: Maybe<Scalars['String']>;
  auto_complete_duration?: Maybe<Scalars['String']>;
  accepted_at?: Maybe<Scalars['String']>;
  expired_at?: Maybe<Scalars['String']>;
  ready_at?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  prep_time_duration?: Maybe<Scalars['String']>;
  rejected_at?: Maybe<Scalars['String']>;
  placed_at?: Maybe<Scalars['String']>;
  pickup_at?: Maybe<Scalars['String']>;
  picked_up_at?: Maybe<Scalars['String']>;
  canceled_at?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['String']>;
};

export type UpdateOrderInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditOrderInput>;
};

export type EditOrderInput = {
  square_id?: Maybe<Scalars['String']>;
  location_id?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  line_items?: Maybe<Array<Maybe<EditComponentOrderLineItemInput>>>;
  fulfillments?: Maybe<Array<Maybe<EditComponentOrderFulfillmentInput>>>;
  created_at?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  closed_at?: Maybe<Scalars['String']>;
  state?: Maybe<Enum_Order_State>;
  version?: Maybe<Scalars['Int']>;
  total_money?: Maybe<EditComponentMoneyPriceMoneyInput>;
  total_tax_money?: Maybe<EditComponentMoneyPriceMoneyInput>;
  total_discount_money?: Maybe<EditComponentMoneyPriceMoneyInput>;
  receipt_url?: Maybe<Scalars['String']>;
  receipt_number?: Maybe<Scalars['String']>;
  total_tip_money?: Maybe<EditComponentMoneyPriceMoneyInput>;
  current_pickup_at?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentOrderLineItemInput = {
  id?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['String']>;
  catalog_object_id?: Maybe<Scalars['String']>;
  modifiers?: Maybe<Array<Maybe<EditComponentOrderOrderLineItemModifierInput>>>;
  note?: Maybe<Scalars['String']>;
};

export type EditComponentOrderOrderLineItemModifierInput = {
  id?: Maybe<Scalars['ID']>;
  catalog_object_id?: Maybe<Scalars['String']>;
};

export type EditComponentOrderFulfillmentInput = {
  id?: Maybe<Scalars['ID']>;
  pickup_details?: Maybe<EditComponentOrderFulfillmentPickupDetailInput>;
  state?: Maybe<Enum_Componentorderfulfillment_State>;
  type?: Maybe<Enum_Componentorderfulfillment_Type>;
  uid?: Maybe<Scalars['String']>;
};

export type EditComponentOrderFulfillmentPickupDetailInput = {
  id?: Maybe<Scalars['ID']>;
  pickup_window_duration?: Maybe<Scalars['String']>;
  schedule_type?: Maybe<Enum_Componentorderfulfillmentpickupdetails_Schedule_Type>;
  cancel_reason?: Maybe<Scalars['String']>;
  auto_complete_duration?: Maybe<Scalars['String']>;
  accepted_at?: Maybe<Scalars['String']>;
  expired_at?: Maybe<Scalars['String']>;
  ready_at?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  prep_time_duration?: Maybe<Scalars['String']>;
  rejected_at?: Maybe<Scalars['String']>;
  placed_at?: Maybe<Scalars['String']>;
  pickup_at?: Maybe<Scalars['String']>;
  picked_up_at?: Maybe<Scalars['String']>;
  canceled_at?: Maybe<Scalars['String']>;
  expires_at?: Maybe<Scalars['String']>;
};

export type DeleteOrderInput = {
  where?: Maybe<InputId>;
};

export type CreatePaymentInput = {
  data?: Maybe<PaymentInput>;
};

export type PaymentInput = {
  square_id?: Maybe<Scalars['String']>;
  amount_money?: Maybe<ComponentMoneyPriceMoneyInput>;
  tip_money?: Maybe<ComponentMoneyPriceMoneyInput>;
  total_money?: Maybe<ComponentMoneyPriceMoneyInput>;
  app_fee_money?: Maybe<ComponentMoneyPriceMoneyInput>;
  processing_fee?: Maybe<Array<Maybe<ComponentMoneyProcessingFeeInput>>>;
  refunded_money?: Maybe<ComponentMoneyPriceMoneyInput>;
  status?: Maybe<Enum_Payment_Status>;
  source_type?: Maybe<Enum_Payment_Source_Type>;
  location_id?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  buyer_email_address?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  receipt_number?: Maybe<Scalars['String']>;
  receipt_url?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type ComponentMoneyProcessingFeeInput = {
  effective_at?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Componentmoneyprocessingfee_Type>;
  amount_money?: Maybe<ComponentMoneyPriceMoneyInput>;
};

export type UpdatePaymentInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditPaymentInput>;
};

export type EditPaymentInput = {
  square_id?: Maybe<Scalars['String']>;
  amount_money?: Maybe<EditComponentMoneyPriceMoneyInput>;
  tip_money?: Maybe<EditComponentMoneyPriceMoneyInput>;
  total_money?: Maybe<EditComponentMoneyPriceMoneyInput>;
  app_fee_money?: Maybe<EditComponentMoneyPriceMoneyInput>;
  processing_fee?: Maybe<Array<Maybe<EditComponentMoneyProcessingFeeInput>>>;
  refunded_money?: Maybe<EditComponentMoneyPriceMoneyInput>;
  status?: Maybe<Enum_Payment_Status>;
  source_type?: Maybe<Enum_Payment_Source_Type>;
  location_id?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['String']>;
  reference_id?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  buyer_email_address?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  receipt_number?: Maybe<Scalars['String']>;
  receipt_url?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditComponentMoneyProcessingFeeInput = {
  id?: Maybe<Scalars['ID']>;
  effective_at?: Maybe<Scalars['String']>;
  type?: Maybe<Enum_Componentmoneyprocessingfee_Type>;
  amount_money?: Maybe<EditComponentMoneyPriceMoneyInput>;
};

export type DeletePaymentInput = {
  where?: Maybe<InputId>;
};

export type CreateRoleInput = {
  data?: Maybe<RoleInput>;
};

export type RoleInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateRoleInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditRoleInput>;
};

export type EditRoleInput = {
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Scalars['ID']>>>;
  users?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteRoleInput = {
  where?: Maybe<InputId>;
};

export type CreateUserInput = {
  data?: Maybe<UserInput>;
};

export type UserInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  squareCustomerId?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type UpdateUserInput = {
  where?: Maybe<InputId>;
  data?: Maybe<EditUserInput>;
};

export type EditUserInput = {
  username?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  blocked?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['ID']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  squareCustomerId?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type DeleteUserInput = {
  where?: Maybe<InputId>;
};

export type CreatePaymentRequestInput = {
  source_id: Scalars['String'];
  clientIdempotencyKey?: Maybe<Scalars['String']>;
  tip_money?: Maybe<ComponentMoneyPriceMoneyInput>;
};

export type OrderFulfillmentRecipientInput = {
  customer_id?: Maybe<Scalars['String']>;
  display_name?: Maybe<Scalars['String']>;
  email_address?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  address?: Maybe<ComponentAddressAddressInput>;
};


export type UsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Maybe<Scalars['String']>;
};

export type UsersPermissionsRegisterInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};

export type UsersPermissionsRegisterEnhancedInput = {
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type UserContactUpdateInput = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type JooAdminInput = {
  catalogSyncInProgress?: Maybe<Scalars['Boolean']>;
  catalogSyncRequested?: Maybe<Scalars['Boolean']>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type FileInput = {
  name: Scalars['String'];
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  ext?: Maybe<Scalars['String']>;
  mime: Scalars['String'];
  size: Scalars['Float'];
  url: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};

export type EditFileInput = {
  name?: Maybe<Scalars['String']>;
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  formats?: Maybe<Scalars['JSON']>;
  hash?: Maybe<Scalars['String']>;
  ext?: Maybe<Scalars['String']>;
  mime?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<Scalars['ID']>>>;
  created_by?: Maybe<Scalars['ID']>;
  updated_by?: Maybe<Scalars['ID']>;
};



export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}
